<template>
    <v-container fluid>
        <v-row>
            <v-col cols="12">
                <v-tabs left v-model="tabMain">
                    <v-tab @click.native.prevent="changeTab('information')" key="information" href="#information">
                        {{ $t('tabs.applicationInformation') }}
                    </v-tab>
                    <v-tab
                        v-if="application.id != 0"
                        @click.native.prevent="changeTab('document-checklist')"
                        key="document-checklist"
                        href="#document-checklist"
                    >
                        {{ $t('tabs.documentChecklist') }}
                    </v-tab>
                </v-tabs>
                <v-tabs-items v-model="tab">
                    <v-tab-item
                        key="information"
                        value="information"
                        style="
                            margin-top: 3px;
                            margin-bottom: 0px;
                            scroll-margin: 0px;
                            height: 90vh;
                            overflow-y: scroll;
                            overflow-x: hidden;
                        "
                    >
                        <v-row>
                            <v-col class="pl-5">
                                <v-btn
                                    v-if="inEditMode && application.id != 0"
                                    class="ml-2 mr-2"
                                    color="primary"
                                    @click="saveClick(false)"
                                >
                                    <v-icon small>fa-save</v-icon>&nbsp;{{ $t('buttons.save') }}
                                </v-btn>
                                <v-btn v-if="inEditMode" class="ml-2 mr-2" color="primary" @click="saveClick(true)">
                                    <v-icon small>fa-save</v-icon>&nbsp;{{ $t('buttons.saveAndExit') }}
                                </v-btn>
                                <v-btn
                                    v-if="!inEditMode && !application.gdpr_edit_lock"
                                    class="ml-2 mr-2"
                                    color="primary"
                                    @click="editClick()"
                                >
                                    <v-icon small>fa-edit</v-icon>&nbsp;{{ $t('buttons.edit') }}
                                </v-btn>
                                <v-btn class="mr-2" @click="backClick">
                                    <v-icon small>fa-reply</v-icon>&nbsp;{{ $t('buttons.back') }}
                                </v-btn>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="4">
                                <v-card flat>
                                    <v-card-text>
                                        <v-row dense wrap>
                                            <v-col cols="2" v-if="application.id != 0">
                                                <InputField
                                                    :readonly="true"
                                                    v-model="application.id"
                                                    :label="$t('fields.id')"
                                                ></InputField>
                                            </v-col>
                                            <v-col cols="8">
                                                <Dropdown
                                                    :readonly="!inEditMode"
                                                    v-model="application.vacancy_id"
                                                    :ajax="true"
                                                    :data="'vacancies'"
                                                    :errorBorder="!applicationValidation.vacancy_id"
                                                    :label="$t('fields.assignToVacancy')"
                                                ></Dropdown>
                                            </v-col>
                                            <v-col cols="2">
                                                <v-tooltip bottom v-if="application.vacancy_id != null">
                                                    <template v-slot:activator="{on, attrs}">
                                                        <v-icon
                                                            class="pl-2 pt-2"
                                                            v-bind="attrs"
                                                            v-on="on"
                                                            @click="openVacancy()"
                                                            medium
                                                            >fas fa-link</v-icon
                                                        >
                                                    </template>
                                                    <span>{{ $t('tooltips.openVacancyInNewTab') }}</span>
                                                </v-tooltip>
                                            </v-col>
                                        </v-row>
                                    </v-card-text>
                                </v-card>
                            </v-col>
                            <v-col cols="4">
                                <v-card flat>
                                    <v-card-text>
                                        <v-row dense wrap>
                                            <v-col cols="12">
                                                <DatePicker
                                                    :readonly="true"
                                                    v-model="application.created_at"
                                                    :date-label="$t('fields.dateCreated')"
                                                ></DatePicker>
                                            </v-col>
                                        </v-row>
                                    </v-card-text>
                                </v-card>
                            </v-col>
                            <v-col cols="4">
                                <v-card flat>
                                    <v-card-text>
                                        <v-row dense wrap>
                                            <!-- <v-col cols="12" v-if="application.id == 0">
                                                <Dropdown
                                                    :readonly="!inEditMode"
                                                    v-model="application.application_status_id"
                                                    :ajax="true"
                                                    :data="'application-statuses-new'"
                                                    :errorBorder="!applicationValidation.application_status_id"
                                                    :label="'* ' + $t('fields.status')"
                                                ></Dropdown>
                                            </v-col> -->
                                            <v-col cols="12">
                                                <Dropdown
                                                    :readonly="!inEditMode"
                                                    v-model="application.application_status_id"
                                                    :ajax="true"
                                                    :data="'application-statuses'"
                                                    :errorBorder="!applicationValidation.application_status_id"
                                                    :label="'* ' + $t('fields.status')"
                                                ></Dropdown>
                                            </v-col>
                                        </v-row>
                                    </v-card-text>
                                </v-card>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="4">
                                <v-card flat>
                                    <v-card-title>
                                        {{ $t('labels.candidateInformation') }}
                                    </v-card-title>
                                    <v-card-text>
                                        <v-row dense wrap>
                                            <v-col cols="9">
                                                <Dropdown2
                                                    :readonly="!inEditMode"
                                                    v-model="application.seafarer_id"
                                                    :ajax="true"
                                                    :data="'seafarers'"
                                                    :errorBorder="!applicationValidation.seafarer_id"
                                                    :label="$t('fields.seafarer')"
                                                    :clearable="true"
                                                ></Dropdown2>
                                            </v-col>
                                            <v-col cols="3">
                                                <v-btn
                                                    v-if="inEditMode"
                                                    class="ml-2 mr-2"
                                                    color="primary"
                                                    @click="assignSeafarer(true)"
                                                >
                                                    <v-icon small>fa-plus</v-icon>&nbsp;{{ $t('buttons.assign') }}
                                                </v-btn>
                                            </v-col>
                                            <v-col cols="12">
                                                <InputField
                                                    :readonly="
                                                        !inEditMode || (inEditMode && application.seafarer_id != null)
                                                    "
                                                    :maxlength="50"
                                                    v-model="application.name"
                                                    :errorBorder="!applicationValidation.name"
                                                    :label="$t('fields.name')"
                                                ></InputField>
                                            </v-col>
                                            <v-col cols="12">
                                                <InputField
                                                    :readonly="
                                                        !inEditMode || (inEditMode && application.seafarer_id != null)
                                                    "
                                                    :maxlength="50"
                                                    v-model="application.surname"
                                                    :errorBorder="!applicationValidation.surname"
                                                    :label="$t('fields.surname')"
                                                ></InputField>
                                            </v-col>
                                            <v-col cols="12">
                                                <InputField
                                                    :readonly="
                                                        !inEditMode || (inEditMode && application.seafarer_id != null)
                                                    "
                                                    :maxlength="50"
                                                    v-model="application.email"
                                                    :errorBorder="!applicationValidation.email"
                                                    :label="$t('fields.email')"
                                                ></InputField>
                                            </v-col>
                                            <v-col cols="12">
                                                <InputField
                                                    :readonly="
                                                        !inEditMode || (inEditMode && application.seafarer_id != null)
                                                    "
                                                    :maxlength="50"
                                                    v-model="application.phone"
                                                    :errorBorder="!applicationValidation.phone"
                                                    :label="$t('fields.phoneNumber')"
                                                ></InputField>
                                            </v-col>
                                            <v-col cols="12">
                                                <Dropdown2
                                                    :readonly="
                                                        !inEditMode || (inEditMode && application.seafarer_id != null)
                                                    "
                                                    v-model="application.nationality_id"
                                                    :ajax="true"
                                                    :data="'nationalities'"
                                                    :errorBorder="!applicationValidation.nationality_id"
                                                    :label="$t('fields.nationality')"
                                                ></Dropdown2>
                                            </v-col>
                                            <v-col cols="12">
                                                <InputField
                                                    :readonly="
                                                        !inEditMode || (inEditMode && application.seafarer_id != null)
                                                    "
                                                    :maxlength="50"
                                                    v-model="application.seafarer_book"
                                                    :errorBorder="!applicationValidation.seafarer_book"
                                                    :label="$t('fields.seamanBook')"
                                                ></InputField>
                                            </v-col>
                                            <v-col cols="12">
                                                <Upload
                                                    :readonly="!inEditMode"
                                                    v-model="application.candidate_resume"
                                                    :errorBorder="!applicationValidation.candidate_resume"
                                                ></Upload>
                                            </v-col>
                                            <v-col
                                                cols="12"
                                                v-if="
                                                    application.seafarer_id == null &&
                                                    $route.params.id != 0 &&
                                                    application.full_application == false
                                                "
                                            >
                                                <v-btn class="ml-2 mr-2" color="primary" @click="addToDatabase(true)">
                                                    <v-icon small>fa-plus</v-icon>&nbsp;{{
                                                        $t('buttons.addToDatabase')
                                                    }}
                                                </v-btn>
                                            </v-col>
                                        </v-row>
                                    </v-card-text>
                                </v-card>
                            </v-col>
                            <v-col cols="4">
                                <v-card flat>
                                    <v-card-title>
                                        {{ $t('labels.applicationInformation') }}
                                    </v-card-title>
                                    <v-card-text>
                                        <v-row dense wrap>
                                            <v-col cols="12">
                                                <Dropdown
                                                    :readonly="!inEditMode"
                                                    v-model="application.rank_id"
                                                    :ajax="true"
                                                    :data="'ranks-abbreviation'"
                                                    :errorBorder="!applicationValidation.rank_id"
                                                    :label="$t('fields.rank')"
                                                ></Dropdown>
                                            </v-col>
                                            <v-col cols="12">
                                                <DropdownMultiple
                                                    :readonly="!inEditMode"
                                                    v-model="vesselExperiences"
                                                    :ajax="true"
                                                    :data="'vessel-types'"
                                                    :label="$t('fields.vesselExperience')"
                                                ></DropdownMultiple>
                                            </v-col>
                                            <v-col cols="12">
                                                <TextArea
                                                    :readonly="!inEditMode"
                                                    :maxlength="1000"
                                                    v-model="application.status_notes"
                                                    :errorBorder="!applicationValidation.status_notes"
                                                    :label="$t('fields.notes')"
                                                ></TextArea>
                                            </v-col>
                                        </v-row>
                                    </v-card-text>
                                </v-card>
                            </v-col>
                            <v-col cols="4">
                                <v-card flat>
                                    <v-card-title>
                                        {{ $t('labels.placementPreparation') }}
                                    </v-card-title>
                                    <v-card-text>
                                        <v-row dense wrap>
                                            <v-col cols="12">
                                                <Dropdown
                                                    :readonly="!inEditMode"
                                                    v-model="application.maritime_object_id"
                                                    :ajax="true"
                                                    :data="'maritime-objects'"
                                                    :errorBorder="!applicationValidation.maritime_object_id"
                                                    :label="'* ' + $t('fields.maritimeObject')"
                                                ></Dropdown>
                                            </v-col>
                                            <v-col cols="6">
                                                <Dropdown
                                                    :readonly="!inEditMode"
                                                    v-model="application.seniority"
                                                    :ajax="false"
                                                    :data="seniorityList"
                                                    :errorBorder="!applicationValidation.seniority"
                                                    :label="'* ' + $t('fields.seniority')"
                                                ></Dropdown>
                                            </v-col>
                                            <v-col cols="12">
                                                <DatePicker
                                                    :readonly="!inEditMode"
                                                    v-model="application.sign_on_date"
                                                    :errorBorder="!applicationValidation.sign_on_date"
                                                    :date-label="$t('fields.signOnPlanned')"
                                                ></DatePicker>
                                            </v-col>
                                            <v-col
                                                cols="12"
                                                v-if="
                                                    application.maritime_object_id != null &&
                                                    application.seniority != null &&
                                                    application.sign_on_date != null &&
                                                    application.rank_id != null &&
                                                    application.seafarer_id != null
                                                "
                                            >
                                                <v-btn
                                                    v-if="!inEditMode"
                                                    class="mr-2"
                                                    color="secondary"
                                                    @click="createPlacement(true)"
                                                >
                                                    <v-icon small>fa-check</v-icon>&nbsp;{{
                                                        $t('buttons.planSeafarer')
                                                    }}
                                                </v-btn>
                                            </v-col>
                                        </v-row>
                                    </v-card-text>
                                </v-card>
                                <v-card flat v-if="application.id != null && application.id != 0">
                                    <v-card-title>
                                        {{ $t('labels.communication') }}
                                    </v-card-title>
                                    <v-card-text>
                                        <v-row dense wrap>
                                            <v-col>
                                                <v-data-table
                                                    :items="notesList"
                                                    fixed-header
                                                    dense
                                                    class="row-item"
                                                    :items-per-page="-1"
                                                    :hide-default-header="true"
                                                    :hide-default-footer="true"
                                                    :height="240"
                                                    :no-data-text="''"
                                                >
                                                    <template v-slot:item="row">
                                                        <tr>
                                                            <td>
                                                                <v-row dense>
                                                                    <v-col cols="2">
                                                                        {{ row.item.userData }} <br />
                                                                        {{ row.item.timestampdata }}
                                                                    </v-col>
                                                                    <v-col cols="10">
                                                                        <TextArea
                                                                            :readonly="true"
                                                                            v-model="row.item.note"
                                                                            :height="50"
                                                                        ></TextArea></v-col
                                                                ></v-row>
                                                            </td>
                                                        </tr>
                                                    </template>
                                                    <template v-slot:footer v-if="inEditMode">
                                                        <v-row dense>
                                                            <v-col cols="10">
                                                                <TextArea
                                                                    :readonly="!inEditMode"
                                                                    :maxlength="500"
                                                                    v-model="note.note"
                                                                    :label="$t('fields.notes')"
                                                                ></TextArea>
                                                            </v-col>
                                                            <v-col cols="2">
                                                                <v-btn
                                                                    class="ml-2 mr-2"
                                                                    color="primary"
                                                                    @click="saveNote()"
                                                                >
                                                                    <v-icon small>fa-save</v-icon>
                                                                </v-btn>
                                                            </v-col>
                                                        </v-row>
                                                    </template>
                                                </v-data-table>
                                            </v-col>
                                        </v-row>
                                    </v-card-text>
                                </v-card>
                            </v-col>
                        </v-row>
                        <v-row v-if="application.seafarer_id == null && application.full_application == true">
                            <v-col cols="4">
                                <v-card flat>
                                    <v-card-title>
                                        {{ $t('labels.candidateProfileInformation') }}
                                    </v-card-title>
                                    <v-card-text>
                                        <v-row dense wrap>
                                            <v-col cols="12">
                                                <DatePicker
                                                    :readonly="!inEditMode"
                                                    v-model="application.available_date"
                                                    :errorBorder="!applicationValidation.available_date"
                                                    :date-label="$t('fields.availableDate')"
                                                ></DatePicker>
                                            </v-col>
                                            <v-col cols="12">
                                                <DatePicker
                                                    :readonly="!inEditMode"
                                                    v-model="application.date_of_birth"
                                                    :errorBorder="!applicationValidation.date_of_birth"
                                                    :date-label="$t('fields.dateOfBirth')"
                                                ></DatePicker>
                                            </v-col>
                                            <v-col cols="12">
                                                <InputField
                                                    :readonly="!inEditMode"
                                                    :maxlength="50"
                                                    v-model="application.oib"
                                                    :errorBorder="!applicationValidation.oib"
                                                    :label="$t('fields.nationalIdentifierOIB')"
                                                ></InputField>
                                            </v-col>
                                            <v-col cols="12">
                                                <Dropdown
                                                    :readonly="!inEditMode"
                                                    v-model="application.country_of_residency_id"
                                                    :ajax="true"
                                                    :data="'countries'"
                                                    :errorBorder="!applicationValidation.country_of_residency_id"
                                                    :label="'* ' + $t('fields.countryOfResidency')"
                                                ></Dropdown>
                                            </v-col>
                                            <v-col cols="12">
                                                <InputField
                                                    :readonly="!inEditMode"
                                                    v-model="application.place_of_birth"
                                                    :errorBorder="!applicationValidation.place_of_birth"
                                                    :label="'* ' + $t('fields.placeOfBirth')"
                                                ></InputField>
                                            </v-col>
                                            <v-col cols="12">
                                                <Dropdown
                                                    :readonly="!inEditMode"
                                                    v-model="application.gender_id"
                                                    :ajax="true"
                                                    :data="'genders'"
                                                    :errorBorder="!applicationValidation.gender_id"
                                                    :label="'* ' + $t('fields.gender')"
                                                ></Dropdown>
                                            </v-col>
                                            <v-col cols="12">
                                                <Dropdown
                                                    :readonly="!inEditMode"
                                                    v-model="application.marital_status_id"
                                                    :ajax="true"
                                                    :data="'marital-statuses'"
                                                    :errorBorder="!applicationValidation.marital_status_id"
                                                    :label="'* ' + $t('fields.maritalStatus')"
                                                ></Dropdown>
                                            </v-col>
                                            <v-col cols="12">
                                                <Dropdown
                                                    :readonly="!inEditMode"
                                                    v-model="application.account_currency_id"
                                                    :ajax="true"
                                                    :data="'currencies-with-exchange'"
                                                    :errorBorder="!applicationValidation.account_currency_id"
                                                    :label="'* ' + $t('fields.accountCurrency')"
                                                ></Dropdown>
                                            </v-col>
                                        </v-row>
                                    </v-card-text>
                                </v-card>
                            </v-col>
                            <v-col cols="4">
                                <v-card flat>
                                    <v-card-title>
                                        {{ $t('labels.candidateAddressInformation') }}
                                    </v-card-title>
                                    <v-card-text>
                                        <v-row dense wrap>
                                            <v-col cols="12">
                                                <InputField
                                                    :readonly="!inEditMode"
                                                    v-model="application.street_name_and_number"
                                                    :errorBorder="!applicationValidation.street_name_and_number"
                                                    :label="'* ' + $t('fields.streetNameAndNumber')"
                                                ></InputField>
                                            </v-col>
                                            <v-col cols="12">
                                                <InputField
                                                    :readonly="!inEditMode"
                                                    v-model="application.city"
                                                    :errorBorder="!applicationValidation.city"
                                                    :label="'* ' + $t('fields.city')"
                                                ></InputField>
                                            </v-col>
                                            <v-col cols="12">
                                                <InputField
                                                    :readonly="!inEditMode"
                                                    v-model="application.post_code"
                                                    :errorBorder="!applicationValidation.post_code"
                                                    :label="'* ' + $t('fields.postalCode')"
                                                ></InputField>
                                            </v-col>
                                            <v-col cols="12">
                                                <Dropdown
                                                    :readonly="!inEditMode"
                                                    v-model="application.country_id"
                                                    :ajax="true"
                                                    :data="'countries'"
                                                    :errorBorder="!applicationValidation.country_id"
                                                    :label="'* ' + $t('fields.country')"
                                                ></Dropdown>
                                            </v-col>
                                            <v-col cols="12">
                                                <Dropdown
                                                    :readonly="!inEditMode"
                                                    v-model="application.airport_id"
                                                    :ajax="true"
                                                    :data="'airports'"
                                                    :errorBorder="!applicationValidation.airport_id"
                                                    :label="'* ' + $t('fields.closestIntAirport')"
                                                ></Dropdown>
                                            </v-col>
                                        </v-row>
                                    </v-card-text>
                                </v-card>
                            </v-col>
                            <v-col cols="4">
                                <v-card flat>
                                    <v-card-title>
                                        {{ $t('labels.candidateNextOfKinInformation') }}
                                    </v-card-title>
                                    <v-card-text>
                                        <v-row dense wrap>
                                            <v-col cols="12">
                                                <InputField
                                                    v-model="application.emergency_contact_name"
                                                    :errorBorder="!applicationValidation.emergency_contact_name"
                                                    :label="'* ' + $t('fields.emergencyContactName')"
                                                ></InputField>
                                            </v-col>
                                            <v-col cols="12">
                                                <Dropdown
                                                    v-model="application.emergency_contact_relationship_id"
                                                    :ajax="true"
                                                    :data="'emergency-contact-relationship'"
                                                    :errorBorder="
                                                        !applicationValidation.emergency_contact_relationship_id
                                                    "
                                                    :label="'* ' + $t('fields.emergencyContactRelationship')"
                                                ></Dropdown>
                                            </v-col>
                                            <v-col cols="12">
                                                <InputField
                                                    v-model="application.emergency_contact_street_name_and_number"
                                                    :errorBorder="
                                                        !applicationValidation.emergency_contact_street_name_and_number
                                                    "
                                                    :label="'* ' + $t('fields.streetNameAndNumber')"
                                                ></InputField>
                                            </v-col>
                                            <v-col cols="12">
                                                <InputField
                                                    v-model="application.emergency_contact_city"
                                                    :errorBorder="!applicationValidation.emergency_contact_city"
                                                    :label="'* ' + $t('fields.city')"
                                                ></InputField>
                                            </v-col>
                                            <v-col cols="12">
                                                <InputField
                                                    v-model="application.emergency_contact_post_code"
                                                    :errorBorder="!applicationValidation.emergency_contact_post_code"
                                                    :label="'* ' + $t('fields.postalCode')"
                                                ></InputField>
                                            </v-col>
                                            <v-col cols="12">
                                                <Dropdown
                                                    v-model="application.emergency_contact_country_id"
                                                    :ajax="true"
                                                    :data="'countries'"
                                                    :errorBorder="!applicationValidation.emergency_contact_country_id"
                                                    :label="'* ' + $t('fields.country')"
                                                ></Dropdown>
                                            </v-col>
                                            <v-col cols="12">
                                                <InputField
                                                    v-model="application.contact_number"
                                                    :errorBorder="!applicationValidation.contact_number"
                                                    :label="'* ' + $t('fields.emergencyContactNumber')"
                                                ></InputField>
                                            </v-col>
                                            <v-col cols="12">
                                                <InputField
                                                    v-model="application.contact_email"
                                                    :errorBorder="!applicationValidation.contact_email"
                                                    :label="'* ' + $t('fields.emergencyContactEmail')"
                                                ></InputField>
                                            </v-col>
                                        </v-row>
                                    </v-card-text>
                                </v-card>
                            </v-col>
                        </v-row>
                        <v-row v-if="application.seafarer_id == null && application.full_application == true">
                            <v-col cols="6">
                                <v-card flat>
                                    <v-card-title>
                                        {{ $t('labels.candidateEducation') }}
                                        <v-btn
                                            class="ml-2 mr-2"
                                            color="primary"
                                            @click="addEducationDialog = true"
                                            v-if="inEditMode"
                                        >
                                            <v-icon small>fas fa-plus</v-icon>
                                        </v-btn>
                                    </v-card-title>
                                    <v-card-text>
                                        <v-simple-table>
                                            <template v-slot:default>
                                                <thead>
                                                    <tr>
                                                        <th class="text-left">{{ $t('fields.schoolName') }}</th>
                                                        <th class="text-left">{{ $t('fields.from') }}</th>
                                                        <th class="text-left">{{ $t('fields.to') }}</th>
                                                        <th class="text-left" v-if="inEditMode">
                                                            {{ $t('buttons.delete') }}
                                                        </th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr v-for="(item, index) in educationItems" :key="index">
                                                        <td>{{ item.school_name }}</td>
                                                        <td>{{ item.date_from_display }}</td>
                                                        <td>{{ item.date_to_display }}</td>
                                                        <td class="pl-1">
                                                            <v-btn
                                                                v-if="inEditMode"
                                                                class="ml-2 mr-2"
                                                                color="secondary"
                                                                @click="removeEducation(index)"
                                                            >
                                                                <v-icon small>fa-trash</v-icon>
                                                            </v-btn>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </template>
                                        </v-simple-table>
                                    </v-card-text>
                                </v-card>
                            </v-col>
                            <v-col cols="6">
                                <v-card flat>
                                    <v-card-title>
                                        {{ $t('labels.candidateLanguages') }}
                                        <v-btn
                                            class="ml-2 mr-2"
                                            color="primary"
                                            @click="addLanguageDialog = true"
                                            v-if="inEditMode"
                                        >
                                            <v-icon small>fas fa-plus</v-icon>
                                        </v-btn>
                                    </v-card-title>
                                    <v-card-text>
                                        <v-simple-table>
                                            <template v-slot:default>
                                                <thead>
                                                    <tr>
                                                        <th class="text-left">{{ $t('fields.language') }}</th>
                                                        <th class="text-left">{{ $t('fields.rating') }}</th>
                                                        <th class="text-left">{{ $t('fields.level') }}</th>
                                                        <th class="text-left" v-if="inEditMode">
                                                            {{ $t('buttons.delete') }}
                                                        </th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr v-for="(item, index) in languagesItems" :key="index">
                                                        <td>{{ item.language_display }}</td>
                                                        <td class="pl-2">
                                                            <v-rating
                                                                :readonly="!inEditMode"
                                                                v-model="item.level"
                                                                color="primary"
                                                                background-color="grey darken-1"
                                                                length="4"
                                                                size="30"
                                                            ></v-rating>
                                                        </td>
                                                        <td>
                                                            {{ levelString(item.level) }}
                                                        </td>
                                                        <td class="pl-1">
                                                            <v-btn
                                                                v-if="inEditMode"
                                                                class="ml-2 mr-2 mt-1"
                                                                color="secondary"
                                                                @click="removeLanguage(index)"
                                                            >
                                                                <v-icon small>fa-trash</v-icon>
                                                            </v-btn>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </template>
                                        </v-simple-table>
                                    </v-card-text>
                                </v-card>
                            </v-col>
                        </v-row>
                        <v-row v-if="application.seafarer_id == null && application.full_application == true">
                            <v-col cols="12">
                                <v-card flat>
                                    <v-card-title>
                                        {{ $t('labels.candidateSeaService') }}
                                        <v-btn
                                            class="ml-2 mr-2"
                                            color="primary"
                                            @click="addNavigationDialog = true"
                                            v-if="inEditMode"
                                        >
                                            <v-icon small>fas fa-plus</v-icon>
                                        </v-btn>
                                    </v-card-title>
                                    <v-card-text>
                                        <v-simple-table>
                                            <template v-slot:default>
                                                <thead>
                                                    <tr>
                                                        <th class="text-left">{{ $t('fields.companyName') }}</th>
                                                        <th class="text-left">{{ $t('fields.rank') }}</th>
                                                        <th class="text-left">{{ $t('fields.vesselName') }}</th>
                                                        <th class="text-left">{{ $t('fields.signedOn') }}</th>
                                                        <th class="text-left">{{ $t('fields.signedOff') }}</th>
                                                        <th class="text-left">{{ $t('fields.durationDays') }}</th>
                                                        <th class="text-left">{{ $t('fields.typeOfvessel') }}</th>
                                                        <th class="text-left">{{ $t('fields.dwt') }}</th>
                                                        <th class="text-left">{{ $t('fields.gt') }}</th>
                                                        <th class="text-left">{{ $t('fields.engineType') }}</th>
                                                        <th class="text-left">{{ $t('fields.kW') }}</th>
                                                        <th class="text-left">{{ $t('fields.dpManufacturer') }}</th>
                                                        <th class="text-left">{{ $t('fields.dpType') }}</th>
                                                        <th class="text-left" v-if="inEditMode">
                                                            {{ $t('buttons.delete') }}
                                                        </th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr v-for="(item, index) in navigationItems" :key="index">
                                                        <td>{{ item.entity_name }}</td>
                                                        <td>{{ item.rank_display }}</td>
                                                        <td>{{ item.maritime_object_name }}</td>
                                                        <td>{{ item.signed_on_display }}</td>
                                                        <td>{{ item.signed_off_display }}</td>
                                                        <td>{{ item.duration }}</td>
                                                        <td>{{ item.vessel_type_display }}</td>
                                                        <td>{{ item.dwt }}</td>
                                                        <td>{{ item.gt }}</td>
                                                        <td>{{ item.engine_type_display }}</td>
                                                        <td>{{ item.kw }}</td>
                                                        <td>{{ item.dp_manufacturer_display }}</td>
                                                        <td>{{ item.dp_type_display }}</td>
                                                        <td class="pl-1">
                                                            <v-btn
                                                                v-if="inEditMode"
                                                                class="ml-2 mr-2 mt-1"
                                                                color="secondary"
                                                                @click="removeNavigation(index)"
                                                            >
                                                                <v-icon small>fa-trash</v-icon>
                                                            </v-btn>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </template>
                                        </v-simple-table>
                                    </v-card-text>
                                </v-card></v-col
                            >
                        </v-row>
                        <v-row v-if="application.seafarer_id == null && application.full_application == true">
                            <v-col cols="12">
                                <v-card flat>
                                    <v-card-title>
                                        {{ $t('labels.candidateDocuments') }}
                                        <v-btn
                                            class="ml-2 mr-2"
                                            color="primary"
                                            @click="addDocumentDialog = true"
                                            v-if="inEditMode"
                                        >
                                            <v-icon small>fas fa-plus</v-icon>
                                        </v-btn>
                                    </v-card-title>
                                    <v-card-text>
                                        <v-simple-table>
                                            <template v-slot:default>
                                                <thead>
                                                    <tr>
                                                        <th class="text-left">{{ $t('fields.documentType') }}</th>
                                                        <th class="text-left">{{ $t('fields.issuingCountry') }}</th>
                                                        <th class="text-left">{{ $t('fields.issuedBy') }}</th>
                                                        <th class="text-left">{{ $t('fields.documentNumber') }}</th>
                                                        <th class="text-left">{{ $t('fields.dateIssued') }}</th>
                                                        <th class="text-left">{{ $t('fields.dateOfExpiry') }}</th>
                                                        <th class="text-left">{{ $t('fields.document') }}</th>
                                                        <th class="text-left" v-if="inEditMode">
                                                            {{ $t('buttons.delete') }}
                                                        </th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr v-for="(item, index) in documentItems" :key="index">
                                                        <td>{{ item.document_type_display }}</td>
                                                        <td>{{ item.issuing_country_display }}</td>
                                                        <td>{{ item.issued_by }}</td>
                                                        <td>{{ item.document_number }}</td>
                                                        <td>{{ item.date_issued_display }}</td>
                                                        <td>{{ item.date_of_expiry_display }}</td>
                                                        <td>
                                                            <v-btn
                                                                depressed
                                                                @click="fileClicked(item)"
                                                                icon
                                                                v-if="item.uploaded_file.link != ''"
                                                            >
                                                                <v-icon small>fas fa-download</v-icon>
                                                            </v-btn>
                                                        </td>
                                                        <td class="pl-1">
                                                            <v-btn
                                                                v-if="inEditMode"
                                                                class="ml-2 mr-2 mt-1"
                                                                color="secondary"
                                                                @click="removeDocument(index)"
                                                            >
                                                                <v-icon small>fa-trash</v-icon>
                                                            </v-btn>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </template>
                                        </v-simple-table>
                                    </v-card-text>
                                </v-card></v-col
                            >
                        </v-row>
                        <v-row>
                            <v-col cols="12" class="text-center">
                                <v-col
                                    cols="12"
                                    v-if="
                                        application.seafarer_id == null &&
                                        $route.params.id != 0 &&
                                        application.full_application == true &&
                                        !inEditMode
                                    "
                                >
                                    <v-btn class="ml-2 mr-2" color="primary" @click="addToDatabaseFull(true)">
                                        <v-icon small>fa-plus</v-icon>&nbsp;{{ $t('buttons.addToDatabase') }}
                                    </v-btn>
                                </v-col>
                            </v-col>
                        </v-row>
                    </v-tab-item>
                    <v-tab-item
                        key="document-checklist"
                        value="document-checklist"
                        v-if="application.seafarer_id != null && !inEditMode"
                    >
                        <ApplicationDocumentChecklistsVue
                            :application="application"
                        ></ApplicationDocumentChecklistsVue> </v-tab-item
                ></v-tabs-items>
            </v-col>
        </v-row>
        <v-row>
            <v-dialog v-model="addSeafarerToDatabaseDialog" width="820" persistent>
                <v-card>
                    <v-card-title>
                        {{ $t('labels.newSeafarer') }}
                    </v-card-title>
                    <v-card-text>
                        <v-row dense wrap>
                            <v-col cols="6">
                                <v-row dense wrap>
                                    <v-col cols="12">
                                        <Dropdown
                                            v-model="seafarer.status_id"
                                            :ajax="false"
                                            :data="statuses"
                                            :errorBorder="!seafarerValidation.status_id"
                                            :label="'* ' + $t('fields.status')"
                                        ></Dropdown>
                                    </v-col>
                                    <v-col cols="12">
                                        <Dropdown
                                            v-model="seafarer.rank_id"
                                            :ajax="true"
                                            :data="'ranks'"
                                            :errorBorder="!seafarerValidation.rank_id"
                                            :label="'* ' + $t('fields.rank')"
                                        ></Dropdown>
                                    </v-col>
                                    <v-col cols="12">
                                        <InputField
                                            :maxlength="50"
                                            v-model="seafarer.name"
                                            :errorBorder="!seafarerValidation.name"
                                            :label="'* ' + $t('fields.firstName')"
                                        ></InputField>
                                    </v-col>
                                    <v-col cols="12">
                                        <InputField
                                            :maxlength="50"
                                            v-model="seafarer.surname"
                                            :errorBorder="!seafarerValidation.surname"
                                            :label="'* ' + $t('fields.lastName')"
                                        ></InputField>
                                    </v-col>
                                    <v-col cols="12">
                                        <DatePicker
                                            v-model="seafarer.date_of_birth"
                                            :errorBorder="!seafarerValidation.date_of_birth"
                                            :date-label="'* ' + $t('fields.dateOfBirth')"
                                        ></DatePicker>
                                    </v-col>
                                    <v-col cols="12">
                                        <Dropdown2
                                            v-model="seafarer.nationality_id"
                                            :ajax="true"
                                            :data="'nationalities'"
                                            :errorBorder="!seafarerValidation.nationality_id"
                                            :label="'* ' + $t('fields.nationality')"
                                        ></Dropdown2>
                                    </v-col>
                                    <v-col cols="12">
                                        <Dropdown2
                                            v-model="seafarer.country_of_residency_id"
                                            :ajax="true"
                                            :data="'countries'"
                                            :errorBorder="!seafarerValidation.country_of_residency_id"
                                            :label="'* ' + $t('fields.countryOfResidency')"
                                        ></Dropdown2>
                                    </v-col>
                                    <v-col cols="12">
                                        <InputField
                                            :maxlength="50"
                                            v-model="seafarer.place_of_birth"
                                            :errorBorder="!seafarerValidation.place_of_birth"
                                            :label="'* ' + $t('fields.placeOfBirth')"
                                        ></InputField>
                                    </v-col>
                                    <v-col cols="12">
                                        <Dropdown
                                            v-model="seafarer.gender_id"
                                            :ajax="true"
                                            :data="'genders'"
                                            :errorBorder="!seafarerValidation.gender_id"
                                            :label="'* ' + $t('fields.gender')"
                                        ></Dropdown>
                                    </v-col>
                                    <v-col cols="12">
                                        <Dropdown
                                            v-model="seafarer.marital_status_id"
                                            :ajax="true"
                                            :data="'marital-statuses'"
                                            :errorBorder="!seafarerValidation.marital_status_id"
                                            :label="'* ' + $t('fields.maritalStatus')"
                                        ></Dropdown>
                                    </v-col>
                                    <v-col cols="12">
                                        <InputField
                                            :maxlength="50"
                                            v-model="seafarer.phone"
                                            :errorBorder="!seafarerValidation.phone"
                                            :label="'* ' + $t('fields.phone')"
                                        ></InputField>
                                    </v-col>
                                    <v-col cols="12">
                                        <InputField
                                            :maxlength="50"
                                            v-model="seafarer.email"
                                            :errorBorder="!seafarerValidation.email"
                                            :label="'* ' + $t('fields.email')"
                                            @blur="checkEmailExistance"
                                        ></InputField>
                                    </v-col>
                                </v-row>
                            </v-col>
                            <v-col cosl="6">
                                <v-row dense wrap>
                                    <v-col cols="12">
                                        <InputField
                                            :maxlength="50"
                                            v-model="seafarer.street_name_and_number"
                                            :errorBorder="!seafarerValidation.street_name_and_number"
                                            :label="'* ' + $t('fields.streetNameAndNumber')"
                                        ></InputField>
                                    </v-col>
                                    <v-col cols="12">
                                        <InputField
                                            :maxlength="50"
                                            v-model="seafarer.city"
                                            :errorBorder="!seafarerValidation.city"
                                            :label="'* ' + $t('fields.city')"
                                        ></InputField>
                                    </v-col>
                                    <v-col cols="12">
                                        <InputField
                                            :maxlength="10"
                                            v-model="seafarer.post_code"
                                            :errorBorder="!seafarerValidation.post_code"
                                            :label="'* ' + $t('fields.postalCode')"
                                        ></InputField>
                                    </v-col>
                                    <v-col cols="12">
                                        <Dropdown2
                                            v-model="seafarer.country_id"
                                            :ajax="true"
                                            :data="'countries'"
                                            :errorBorder="!seafarerValidation.country_id"
                                            :label="'* ' + $t('fields.country')"
                                        ></Dropdown2>
                                    </v-col>
                                    <v-col cols="12">
                                        <Dropdown
                                            v-model="seafarer.airport_id"
                                            :ajax="true"
                                            :data="'airports'"
                                            :errorBorder="!seafarerValidation.airport_id"
                                            :label="'* ' + $t('fields.closestIntAirport')"
                                        ></Dropdown>
                                    </v-col>
                                    <v-col cols="12">
                                        <InputField
                                            :maxlength="50"
                                            v-model="seafarer.emergency_contact_name"
                                            :errorBorder="!seafarerValidation.emergency_contact_name"
                                            :label="'* ' + $t('fields.emergencyContactName')"
                                        ></InputField>
                                    </v-col>
                                    <v-col cols="12">
                                        <Dropdown
                                            v-model="seafarer.emergency_contact_relationship_id"
                                            :ajax="true"
                                            :data="'emergency-contact-relationship'"
                                            :errorBorder="!seafarerValidation.emergency_contact_relationship_id"
                                            :label="'* ' + $t('fields.emergencyContactRelationship')"
                                        ></Dropdown>
                                    </v-col>
                                    <v-col cols="12">
                                        <InputField
                                            :maxlength="50"
                                            v-model="seafarer.emergency_contact_street_name_and_number"
                                            :errorBorder="!seafarerValidation.emergency_contact_street_name_and_number"
                                            :label="'* ' + $t('fields.streetNameAndNumber')"
                                        ></InputField>
                                    </v-col>
                                    <v-col cols="12">
                                        <InputField
                                            :maxlength="50"
                                            v-model="seafarer.emergency_contact_city"
                                            :errorBorder="!seafarerValidation.emergency_contact_city"
                                            :label="'* ' + $t('fields.city')"
                                        ></InputField>
                                    </v-col>
                                    <v-col cols="12">
                                        <InputField
                                            :maxlength="10"
                                            v-model="seafarer.emergency_contact_post_code"
                                            :errorBorder="!seafarerValidation.emergency_contact_post_code"
                                            :label="'* ' + $t('fields.postalCode')"
                                        ></InputField>
                                    </v-col>
                                    <v-col cols="12">
                                        <Dropdown2
                                            v-model="seafarer.emergency_contact_country_id"
                                            :ajax="true"
                                            :data="'countries'"
                                            :errorBorder="!seafarerValidation.emergency_contact_country_id"
                                            :label="'* ' + $t('fields.emergencyContactCountry')"
                                        ></Dropdown2>
                                    </v-col>
                                    <v-col cols="12">
                                        <InputField
                                            :maxlength="50"
                                            v-model="seafarer.contact_number"
                                            :errorBorder="!seafarerValidation.contact_number"
                                            :label="'* ' + $t('fields.emergencyContactNumber')"
                                        ></InputField>
                                    </v-col>
                                    <v-col cols="12">
                                        <InputField
                                            :maxlength="50"
                                            v-model="seafarer.contact_email"
                                            :errorBorder="!seafarerValidation.contact_email"
                                            :label="'* ' + $t('fields.emergencyContactEmail')"
                                        ></InputField>
                                    </v-col>
                                    <v-col cols="12">
                                        <Dropdown
                                            v-model="seafarer.account_currency_id"
                                            :ajax="true"
                                            :data="'currencies-with-exchange'"
                                            :errorBorder="!seafarerValidation.account_currency_id"
                                            :label="'* ' + $t('fields.accountCurrency')"
                                        ></Dropdown>
                                    </v-col>
                                </v-row>
                            </v-col>
                        </v-row>
                    </v-card-text>
                    <v-card-actions>
                        <v-col
                            cols="12"
                            md="6"
                            class="text-right"
                            :class="{'text-center': $vuetify.breakpoint.smAndDown}"
                        >
                            <v-btn color="primary" class="white--text" @click.stop="saveNewSeafarer"
                                >{{ $t('buttons.save') }}
                            </v-btn>
                        </v-col>
                        <v-col
                            cols="12"
                            md="6"
                            class="text-left"
                            :class="{'text-center': $vuetify.breakpoint.smAndDown}"
                        >
                            <v-btn color="secondary" class="white--text" @click.stop="closeDialog"
                                >{{ $t('buttons.cancel') }}
                            </v-btn>
                        </v-col>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-row>
        <v-row>
            <v-dialog v-model="addNavigationDialog" persistent width="700">
                <v-card>
                    <v-card-title>
                        {{ $t('labels.newSeaExperienceWithOtherCompanies') }}
                    </v-card-title>
                    <v-card-text>
                        <v-row dense wrap>
                            <v-col cols="6">
                                <v-row dense wrap>
                                    <v-col cols="12">
                                        <InputField
                                            :maxlength="50"
                                            v-model="navigationObject.entity_name"
                                            :errorBorder="!navigationObjectValidation.entity_name"
                                            :label="'* ' + $t('fields.companyName')"
                                        ></InputField>
                                    </v-col>
                                    <v-col cols="12">
                                        <Dropdown
                                            v-model="navigationObject.rank_id"
                                            :errorBorder="!navigationObjectValidation.rank_id"
                                            :ajax="true"
                                            :data="'ranks-abbreviation'"
                                            :label="'* ' + $t('fields.rank')"
                                            @selected="selectedRank"
                                        ></Dropdown>
                                    </v-col>
                                    <v-col cols="12">
                                        <InputField
                                            :maxlength="50"
                                            v-model="navigationObject.maritime_object_name"
                                            :errorBorder="!navigationObjectValidation.maritime_object_name"
                                            :label="'* ' + $t('fields.vessel')"
                                        ></InputField>
                                    </v-col>
                                    <v-col cols="12">
                                        <DatePicker
                                            v-model="navigationObject.signed_on"
                                            :errorBorder="!navigationObjectValidation.signed_on"
                                            :date-label="'* ' + $t('fields.signedOn')"
                                        ></DatePicker>
                                    </v-col>
                                    <v-col cols="12">
                                        <DatePicker
                                            v-model="navigationObject.signed_off"
                                            :errorBorder="!navigationObjectValidation.signed_off"
                                            :date-label="'* ' + $t('fields.signedOff')"
                                        ></DatePicker>
                                    </v-col>
                                    <v-col cols="12">
                                        <InputField
                                            :readonly="true"
                                            :maxlength="50"
                                            v-model="navigationObject.duration"
                                            :errorBorder="!navigationObjectValidation.duration"
                                            :label="'* ' + $t('fields.duration')"
                                        ></InputField>
                                    </v-col>
                                </v-row>
                            </v-col>
                            <v-col cols="6">
                                <v-row dense wrap>
                                    <v-col cols="12">
                                        <Dropdown
                                            v-model="navigationObject.vessel_type_id"
                                            :errorBorder="!navigationObjectValidation.vessel_type_id"
                                            :ajax="true"
                                            :data="'vessel-types'"
                                            :label="$t('fields.vesselType')"
                                            @selected="selectedVesselType"
                                        ></Dropdown>
                                    </v-col>
                                    <v-col cols="12">
                                        <InputField
                                            :maxlength="50"
                                            v-model="navigationObject.dwt"
                                            :errorBorder="!navigationObjectValidation.dwt"
                                            :label="$t('fields.dwt')"
                                        ></InputField>
                                    </v-col>
                                    <v-col cols="12">
                                        <InputField
                                            :maxlength="50"
                                            v-model="navigationObject.gt"
                                            :errorBorder="!navigationObjectValidation.gt"
                                            :label="$t('fields.gt')"
                                        ></InputField>
                                    </v-col>
                                    <v-col cols="12">
                                        <Dropdown
                                            v-model="navigationObject.engine_type_id"
                                            :errorBorder="!navigationObjectValidation.engine_type_id"
                                            :ajax="true"
                                            :data="'engine-types'"
                                            :label="$t('fields.engineType')"
                                            @selected="selectedEngineType"
                                        ></Dropdown>
                                    </v-col>
                                    <v-col cols="12">
                                        <InputField
                                            :maxlength="50"
                                            v-model="navigationObject.kw"
                                            :errorBorder="!navigationObjectValidation.kw"
                                            :label="$t('fields.kW')"
                                        ></InputField>
                                    </v-col>
                                    <v-col cols="12">
                                        <Dropdown
                                            v-model="navigationObject.dp_manufacturer_id"
                                            :errorBorder="!navigationObjectValidation.dp_manufacturer_id"
                                            :ajax="true"
                                            :data="'dp-manufacturers'"
                                            :label="$t('fields.dpManufacturer')"
                                            @selected="selectedManufacturer"
                                        ></Dropdown>
                                    </v-col>
                                    <v-col cols="12">
                                        <Dropdown
                                            v-model="navigationObject.dp_type_id"
                                            :errorBorder="!navigationObjectValidation.dp_type_id"
                                            :ajax="true"
                                            :data="'dp-types'"
                                            :label="$t('fields.dpType')"
                                            @selected="selectedDpType"
                                        ></Dropdown>
                                    </v-col>
                                </v-row>
                            </v-col>
                        </v-row>
                    </v-card-text>
                    <v-card-actions>
                        <v-col
                            cols="12"
                            md="6"
                            class="text-right"
                            :class="{'text-center': $vuetify.breakpoint.smAndDown}"
                        >
                            <v-btn color="primary" class="white--text" @click.stop="saveNavigation()"
                                >{{ $t('buttons.save') }}
                            </v-btn>
                        </v-col>
                        <v-col
                            cols="12"
                            md="6"
                            class="text-left"
                            :class="{'text-center': $vuetify.breakpoint.smAndDown}"
                        >
                            <v-btn color="secondary" class="white--text" @click.stop="closeNavigationDialog()"
                                >{{ $t('buttons.cancel') }}
                            </v-btn>
                        </v-col>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-row>
        <v-row>
            <v-dialog persistent v-model="addDocumentDialog" width="600">
                <v-card>
                    <v-card-title>
                        {{ $t('labels.newDocument') }}
                    </v-card-title>
                    <v-card-text>
                        <v-row>
                            <v-col cols="12">
                                <v-row dense wrap>
                                    <v-col cols="12">
                                        <Dropdown
                                            :ajax="true"
                                            :data="'document-categories'"
                                            :label="'* ' + $t('fields.type')"
                                            @input="reloadDocumentTypes"
                                            v-model="typeId"
                                            @selected="selectedCategory"
                                        ></Dropdown>
                                    </v-col>
                                    <v-col cols="12">
                                        <Dropdown
                                            v-model="documentObject.document_type_id"
                                            :ajax="false"
                                            :data="documentTypes"
                                            :errorBorder="!documentObjectValidation.document_type_id"
                                            :label="'* ' + $t('fields.documentType')"
                                            :key="componentKey"
                                            @selected="selectedType"
                                        ></Dropdown>
                                    </v-col>
                                    <v-col cols="12">
                                        <Dropdown
                                            v-model="documentObject.issuing_country_id"
                                            :ajax="true"
                                            :data="'countries'"
                                            :errorBorder="!documentObjectValidation.issuing_country_id"
                                            :label="$t('fields.issuingCountry')"
                                            @selected="selectedCountry"
                                        ></Dropdown>
                                    </v-col>
                                    <v-col cols="12">
                                        <InputField
                                            v-model="documentObject.issued_by"
                                            :errorBorder="!documentObjectValidation.issued_by"
                                            :label="$t('fields.issuedBy')"
                                        ></InputField>
                                    </v-col>
                                    <v-col cols="12">
                                        <InputField
                                            v-model="documentObject.document_number"
                                            :errorBorder="!documentObjectValidation.document_number"
                                            :label="$t('fields.documentNumber')"
                                        ></InputField>
                                    </v-col>
                                    <v-col cols="12">
                                        <DatePicker
                                            v-model="documentObject.date_issued"
                                            :errorBorder="!documentObjectValidation.date_issued"
                                            :date-label="$t('fields.dateIssued')"
                                        ></DatePicker>
                                    </v-col>
                                    <v-col cols="12" class="pt-4 pb-0 mb-0">
                                        {{ $t('labels.validity') }}
                                    </v-col>
                                    <v-col cols="12" v-if="expirationTypesLoaded" class="pt-0 mt-0">
                                        <v-radio-group
                                            v-model="documentObject.document_expiration_type_id"
                                            row
                                            class="pt-2 mt-0"
                                        >
                                            <v-radio
                                                v-for="(item, key) in documentExpirationTypes"
                                                :key="key"
                                                :label="item.name"
                                                :value="item.id"
                                                color="primary"
                                                style="margin: auto"
                                            >
                                            </v-radio>
                                        </v-radio-group>
                                    </v-col>
                                    <v-col cols="12" v-if="documentObject.document_expiration_type_id">
                                        <DatePicker
                                            :disabled="isDateOfExpiryDisabled"
                                            :readonly="isDateOfExpiryDisabled"
                                            v-model="documentObject.date_of_expiry"
                                            :errorBorder="!documentObjectValidation.date_of_expiry"
                                            :date-label="$t('fields.dateOfExpiry')"
                                        ></DatePicker>
                                    </v-col>
                                    <v-col cols="12">
                                        <Upload
                                            v-model="documentObject.uploaded_file"
                                            :errorBorder="!documentObjectValidation.uploaded_file"
                                        ></Upload>
                                    </v-col>
                                </v-row>
                                <v-row>
                                    <v-col
                                        cols="12"
                                        md="6"
                                        class="text-right"
                                        :class="{'text-center': $vuetify.breakpoint.smAndDown}"
                                    >
                                        <v-btn
                                            color="primary"
                                            class="white--text"
                                            :disabled="!expirationTypesLoaded"
                                            @click.stop="saveDocument"
                                            >{{ $t('buttons.save') }}
                                        </v-btn>
                                    </v-col>
                                    <v-col
                                        cols="12"
                                        md="6"
                                        class="text-left"
                                        :class="{'text-center': $vuetify.breakpoint.smAndDown}"
                                    >
                                        <v-btn color="secondary" class="white--text" @click.stop="closeDocumentDialog"
                                            >{{ $t('buttons.cancel') }}
                                        </v-btn>
                                    </v-col>
                                </v-row>
                            </v-col>
                        </v-row>
                    </v-card-text>
                </v-card>
            </v-dialog>
        </v-row>
        <v-row>
            <v-dialog persistent v-model="addEducationDialog" width="600">
                <v-card>
                    <v-card-title>
                        {{ $t('labels.newEducation') }}
                    </v-card-title>
                    <v-card-text>
                        <v-row>
                            <v-col cols="12">
                                <v-row dense wrap>
                                    <v-col cols="12">
                                        <InputField
                                            :maxlength="50"
                                            v-model="educationObject.school_name"
                                            :errorBorder="!educationObjectValidation.school_name"
                                            :label="'* ' + $t('fields.schoolName')"
                                        ></InputField>
                                    </v-col>
                                    <v-col cols="12">
                                        <DatePicker
                                            v-model="educationObject.date_from"
                                            :errorBorder="!educationObjectValidation.date_from"
                                            :date-label="'* ' + $t('fields.from')"
                                        ></DatePicker>
                                    </v-col>
                                    <v-col cols="12">
                                        <DatePicker
                                            v-model="educationObject.date_to"
                                            :errorBorder="!educationObjectValidation.date_to"
                                            :date-label="'* ' + $t('fields.to')"
                                        ></DatePicker>
                                    </v-col>
                                </v-row>
                                <v-row>
                                    <v-col
                                        cols="12"
                                        md="6"
                                        class="text-right"
                                        :class="{'text-center': $vuetify.breakpoint.smAndDown}"
                                    >
                                        <v-btn color="primary" class="white--text" @click.stop="addEducation"
                                            >{{ $t('buttons.save') }}
                                        </v-btn>
                                    </v-col>
                                    <v-col
                                        cols="12"
                                        md="6"
                                        class="text-left"
                                        :class="{'text-center': $vuetify.breakpoint.smAndDown}"
                                    >
                                        <v-btn color="secondary" class="white--text" @click.stop="closeEducationDialog"
                                            >{{ $t('buttons.cancel') }}
                                        </v-btn>
                                    </v-col>
                                </v-row>
                            </v-col>
                        </v-row>
                    </v-card-text>
                </v-card>
            </v-dialog>
        </v-row>
        <v-row>
            <v-dialog persistent v-model="addLanguageDialog" width="600">
                <v-card>
                    <v-card-title>
                        {{ $t('labels.newLanguage') }}
                    </v-card-title>
                    <v-card-text>
                        <v-row>
                            <v-col cols="12">
                                <v-row dense wrap>
                                    <v-col cols="12">
                                        <Dropdown
                                            v-model="languageObject.language_id"
                                            :ajax="true"
                                            :data="'languages'"
                                            :errorBorder="!languageObjectValidation.language_id"
                                            :label="'* ' + $t('fields.language')"
                                            @selected="selectedLanguage"
                                        ></Dropdown>
                                    </v-col>
                                    <v-col cols="2">
                                        <div style="font-size: large; font-weight: bold; margin-top: 16px">
                                            {{ $t('labels.rating') }}
                                        </div>
                                    </v-col>
                                    <v-col cols="10">
                                        <v-rating
                                            :item-labels="['sad', '', '', '', 'happy']"
                                            v-model="languageObject.level"
                                            color="primary"
                                            background-color="grey darken-1"
                                            hover
                                            length="4"
                                            size="35"
                                        ></v-rating>
                                    </v-col>
                                    <v-col cols="2">
                                        <div style="font-size: large; font-weight: bold">{{ $t('labels.level') }}</div>
                                    </v-col>
                                    <v-col cols="10">
                                        <div style="font-size: large">{{ level }}</div>
                                    </v-col>
                                </v-row>
                                <v-row>
                                    <v-col
                                        cols="12"
                                        md="6"
                                        class="text-right"
                                        :class="{'text-center': $vuetify.breakpoint.smAndDown}"
                                    >
                                        <v-btn color="primary" class="white--text" @click.stop="addLanguage"
                                            >{{ $t('buttons.save') }}
                                        </v-btn>
                                    </v-col>
                                    <v-col
                                        cols="12"
                                        md="6"
                                        class="text-left"
                                        :class="{'text-center': $vuetify.breakpoint.smAndDown}"
                                    >
                                        <v-btn color="secondary" class="white--text" @click.stop="closeLanguageDialog"
                                            >{{ $t('buttons.cancel') }}
                                        </v-btn>
                                    </v-col>
                                </v-row>
                            </v-col>
                        </v-row>
                    </v-card-text>
                </v-card>
            </v-dialog>
        </v-row>
    </v-container>
</template>

<script>
import Placement from '../models/Placement';
import InputField from './trinkets/InputField';
import Dropdown from './trinkets/Dropdown';
import Dropdown2 from './trinkets/Dropdown2';
import Application from '../models/Application';
import ApplicationNote from '../models/ApplicationNote';
import DatePicker from '@/components/trinkets/DatePicker';
import TextArea from '@/components/trinkets/TextArea';
import ApplicationDocumentChecklistsVue from './ApplicationDocumentChecklists.vue';
import DropdownMultiple from './trinkets/DropdownMultiple';
import Upload from '@/components/trinkets/Upload';
import Seafarer from '../models/Seafarer';
import Education from '../models/Education';
import ApplicationLanguage from '../models/ApplicationLanguage';
import ApplicationNavigation from '../models/ApplicationNavigation';
import ApplicationSeafarerDocument from '../models/ApplicationSeafarerDocument';

export default {
    name: 'Applications',
    components: {
        DatePicker,
        InputField,
        Dropdown,
        Dropdown2,
        TextArea,
        ApplicationDocumentChecklistsVue,
        Upload,
        DropdownMultiple,
    },
    data: function () {
        return {
            application: new Application({id: this.$route.params.id}),
            applicationValidation: new Application({}, true),
            initialLoad: false,
            inEditMode: false,
            lockKey: 'application',
            lockTimer: null,
            seniorityList: [
                {value: null, label: 'None'},
                {value: 1, label: '1'},
                {value: 2, label: '2'},
                {value: 3, label: '3'},
                {value: 4, label: '4'},
                {value: 5, label: '5'},
                {value: 6, label: '6'},
                {value: 7, label: '7'},
                {value: 8, label: '8'},
                {value: 9, label: '9'},
                {value: 10, label: '10'},
            ],
            maritimeObjectReadOnly: true,
            note: new ApplicationNote({}),
            notesList: [],
            rankReadOnly: true,
            tabMain: 'information',
            tab: 'information',
            currentTab: 'information',
            vesselExperiences: [],
            seafarer: new Seafarer({}),
            seafarerValidation: new Seafarer({}, true),
            addSeafarerToDatabaseDialog: false,
            statuses: [
                {value: 1, label: 'Inactive (NC)'},
                {value: 2, label: 'Sick Leave - No contract (NC)'},
                {value: 3, label: 'Available (NC)'},
                {value: 4, label: 'On Leave (NC)'},
            ],
            originSeafarerName: '',
            originSeafarerSurname: '',
            originSeafarerEmail: '',
            originSeafarerPhone: '',
            originSeafarerNationalityId: '',
            originSeafarerSeafarerBook: '',
            emailVerified: true,
            educationItems: [],
            educationObject: new Education({}),
            educationObjectValidation: new Education({}, true),
            languagesItems: [],
            languageObject: new ApplicationLanguage({}),
            languageObjectValidation: new ApplicationLanguage({}, true),
            navigationItems: [],
            navigationObject: new ApplicationNavigation({}),
            navigationObjectValidation: new ApplicationNavigation({}, true),
            addNavigationDialog: false,
            documentItems: [],
            documentObject: new ApplicationSeafarerDocument({}),
            documentObjectValidation: new ApplicationSeafarerDocument({}, true),
            addDocumentDialog: false,
            documentTypes: [],
            componentKey: 0,
            expirationTypesLoaded: false,
            documentExpirationTypes: [],
            typeId: null,
            addEducationDialog: false,
            addLanguageDialog: false,
        };
    },

    computed: {
        languages: {
            get() {
                return this.languagesItems;
            },
            set(newItem) {
                return newItem;
            },
        },
        level() {
            return this.levelString(this.languageObject.level);
        },
        isDateOfExpiryDisabled() {
            return (
                this.documentObject.document_expiration_type_id == null ||
                this.documentObject.document_expiration_type_id != 5
            );
        },
    },
    watch: {
        'addDocumentDialog'(newVal) {
            if (newVal) {
                this.loadExpiraitonTypes();
            }
        },
        'documentObject.date_issued': {
            handler: function () {
                if (this.documentObject.date_issued != null && this.documentObject.date_of_expiry != null) {
                    const dateIssued = new Date(this.documentObject.date_issued);
                    const dateOfExpiry = new Date(this.documentObject.date_of_expiry);
                    if (dateIssued > dateOfExpiry) {
                        this.documentObjectValidation.date_issued = false;
                        this.documentObjectValidation.date_of_expiry = false;
                    } else {
                        this.documentObjectValidation.date_issued = true;
                        this.documentObjectValidation.date_of_expiry = true;
                    }
                }
                if (this.documentObject.document_expiration_type_id) {
                    if (
                        this.documentObject.document_expiration_type_id == 1 ||
                        this.documentObject.document_expiration_type_id == 2
                    ) {
                        this.documentObject.date_of_expiry = this.addYearsToDate(
                            this.documentObject.document_expiration_type_id,
                        );
                    } else if (this.documentObject.document_expiration_type_id == 3) {
                        this.documentObject.date_of_expiry = this.addYearsToDate(5);
                    } else {
                        this.documentObject.date_of_expiry = null;
                    }
                }
            },
            deep: true,
        },
        'documentObject.date_of_expiry': {
            handler: function () {
                if (this.documentObject.date_issued != null && this.documentObject.date_of_expiry != null) {
                    const dateIssued = new Date(this.documentObject.date_issued);
                    const dateOfExpiry = new Date(this.documentObject.date_of_expiry);
                    if (dateIssued > dateOfExpiry) {
                        this.documentObjectValidation.date_issued = false;
                        this.documentObjectValidation.date_of_expiry = false;
                    } else {
                        this.documentObjectValidation.date_issued = true;
                        this.documentObjectValidation.date_of_expiry = true;
                    }
                }
            },
            deep: true,
        },
        'documentObject.document_expiration_type_id'(newVal) {
            if (newVal == 1 || newVal == 2) {
                this.documentObject.date_of_expiry = this.addYearsToDate(newVal);
            } else if (newVal == 3) {
                this.documentObject.date_of_expiry = this.addYearsToDate(5);
            } else {
                this.documentObject.date_of_expiry = null;
            }
        },
        'navigationObject.signed_on': {
            handler: function () {
                this.calculateDuration();
            },
            deep: true,
        },
        'navigationObject.signed_off': {
            handler: function () {
                this.calculateDuration();
            },
            deep: true,
        },
        'application.vacancy_id': {
            handler: function () {
                let vm = this;
                if (this.application.vacancy_id === null) {
                    vm.maritimeObjectReadOnly = true;
                    vm.rankReadOnly = true;
                }
            },
            deep: true,
        },
        'application.seafarer_id': {
            handler: function (newVal) {
                if (this.inEditMode && !newVal) {
                    this.application.name = this.originSeafarerName;
                    this.application.surname = this.originSeafarerSurname;
                    this.application.email = this.originSeafarerEmail;
                    this.application.phone = this.originSeafarerPhone;
                    this.application.nationality_id = this.originSeafarerNationalityId;
                    this.application.seafarer_book = this.originSeafarerSeafarerBook;
                }
            },
            deep: true,
        },
    },
    methods: {
        closeEducationDialog() {
            this.addEducationDialog = false;
            this.educationObject = new Education({});
            this.educationObjectValidation = new Education({}, true);
        },
        fileClicked(item) {
            let link = item.uploaded_file.link;
            window.open(link);
        },
        closeDocumentDialog() {
            this.documentObject = new ApplicationSeafarerDocument({});
            this.documentObjectValidation = new ApplicationSeafarerDocument({}, true);
            this.addDocumentDialog = false;
        },
        reloadDocumentTypes() {
            let vm = this;
            this.$APICall('get', 'document-types-for-select/' + this.typeId, {}, (data, succes) => {
                if (succes) {
                    vm.documentTypes = data;
                    vm.componentKey += 1;
                }
            });
        },
        removeDocument(index) {
            this.documentItems.splice(index, 1);
        },
        saveDocument() {
            let succes = true;
            if (this.documentObject.document_type_id == null || this.documentObject.document_type_id == '') {
                succes = false;
                this.documentObjectValidation.document_type_id = false;
            } else {
                this.documentObjectValidation.document_type_id = true;
            }
            if (this.documentObject.uploaded_file.name == null || this.documentObject.uploaded_file.name == '') {
                succes = false;
                this.$alert(this.$t('alerts.uploadFile'));
            }

            if (succes) {
                if (this.documentObject.date_issued) {
                    let date = new Date(this.documentObject.date_issued);
                    this.documentObject.date_issued_display =
                        date.getDate() + '.' + (date.getMonth() + 1) + '.' + date.getFullYear();
                } else {
                    this.documentObject.date_issued_display = '';
                }

                if (this.documentObject.date_of_expiry) {
                    let date = new Date(this.documentObject.date_of_expiry);
                    this.documentObject.date_of_expiry_display =
                        date.getDate() + '.' + (date.getMonth() + 1) + '.' + date.getFullYear();
                } else {
                    this.documentObject.date_of_expiry_display = '';
                }

                this.documentItems.push(this.documentObject);
                this.documentObject = new ApplicationSeafarerDocument({});

                this.addDocumentDialog = false;
            }
        },
        selectedCountry(value) {
            this.documentObject.issuing_country_display = value.label;
        },
        selectedType(value) {
            this.documentObject.document_type_display = value.label;
        },
        selectedCategory(value) {
            this.documentObject.document_name_display = value.label;
        },
        addYearsToDate(years) {
            const currentDate = new Date(this.documentObject.date_issued);
            currentDate.setFullYear(currentDate.getFullYear() + years);

            const year = currentDate.getFullYear();
            const month = String(currentDate.getMonth() + 1).padStart(2, '0');
            const day = String(currentDate.getDate()).padStart(2, '0');

            return `${year}-${month}-${day}`;
        },
        loadExpiraitonTypes() {
            let vm = this;
            this.$APICall('get', 'document-expiration-types', {}, (data, succes) => {
                if (succes) {
                    vm.documentExpirationTypes = data.items;
                    vm.expirationTypesLoaded = true;
                }
            });
        },
        selectedDpType(value) {
            this.navigationObject.dp_type_display = value.label;
        },
        selectedManufacturer(value) {
            this.navigationObject.dp_manufacturer_display = value.label;
        },
        selectedEngineType(value) {
            this.navigationObject.engine_type_display = value.label;
        },
        selectedVesselType(value) {
            this.navigationObject.vessel_type_display = value.label;
        },
        selectedRank(value) {
            this.navigationObject.rank_display = value.label;
        },
        removeNavigation(index) {
            this.navigationItems.splice(index, 1);
        },
        saveNavigation() {
            let success = true;
            if (this.navigationObject.entity_name == null || this.navigationObject.entity_name == '') {
                success = false;
                this.navigationObjectValidation.entity_name = false;
            } else {
                this.navigationObjectValidation.entity_name = true;
            }
            if (
                this.navigationObject.maritime_object_name == null ||
                this.navigationObject.maritime_object_name == ''
            ) {
                success = false;
                this.navigationObjectValidation.maritime_object_name = false;
            } else {
                this.navigationObjectValidation.maritime_object_name = true;
            }
            if (this.navigationObject.rank_id == null || this.navigationObject.rank_id == '') {
                success = false;
                this.navigationObjectValidation.rank_id = false;
            } else {
                this.navigationObjectValidation.rank_id = true;
            }
            if (this.navigationObject.signed_on == null || this.navigationObject.signed_on == '') {
                success = false;
                this.navigationObjectValidation.signed_on = false;
            } else {
                this.navigationObjectValidation.signed_on = true;
            }
            if (this.navigationObject.signed_off == null || this.navigationObject.signed_off == '') {
                success = false;
                this.navigationObjectValidation.signed_off = false;
            } else {
                this.navigationObjectValidation.signed_off = true;
            }

            if (
                this.navigationObjectValidation.signed_on == false ||
                this.navigationObjectValidation.signed_off == false
            ) {
                success = false;
            }
            if (success) {
                this.navigationObject.seafarer_navigation_type_id = 2;
                let date = new Date(this.navigationObject.signed_on);
                this.navigationObject.signed_on_display =
                    date.getDate() + '.' + (date.getMonth() + 1) + '.' + date.getFullYear();

                date = new Date(this.navigationObject.signed_off);
                this.navigationObject.signed_off_display =
                    date.getDate() + '.' + (date.getMonth() + 1) + '.' + date.getFullYear();

                this.navigationItems.push(this.navigationObject);
                this.navigationObject = new ApplicationNavigation({});

                this.closeNavigationDialog();
            }
        },
        closeNavigationDialog() {
            this.navigationObject = new ApplicationNavigation({});
            this.navigationObjectValidation = new ApplicationNavigation({}, true);
            this.addNavigationDialog = false;
        },
        addNavigation() {
            this.addNavigationDialog = true;
        },
        calculateDuration() {
            if (this.navigationObject.signed_on != null && this.navigationObject.signed_off != null) {
                const signedOn = new Date(this.navigationObject.signed_on);
                const signedOff = new Date(this.navigationObject.signed_off);
                if (signedOn <= signedOff) {
                    var time_difference = signedOff.getTime() - signedOn.getTime();
                    var days_difference = time_difference / (1000 * 60 * 60 * 24);
                    this.navigationObject.duration = days_difference;
                    this.navigationObjectValidation.signed_on = true;
                    this.navigationObjectValidation.signed_off = true;
                } else {
                    this.navigationObjectValidation.signed_on = false;
                    this.navigationObjectValidation.signed_off = false;
                }
            }
        },
        levelString(level) {
            if (level == 1) {
                return this.$t('fields.noProfficiency');
            } else if (level == 2) {
                return this.$t('fields.poor');
            } else if (level == 3) {
                return this.$t('fields.good');
            } else if (level == 4) {
                return this.$t('fields.fluent');
            } else {
                return '';
            }
        },
        removeLanguage(index) {
            this.languages.splice(index, 1);
        },
        addLanguage() {
            let success = true;

            if (this.languageObject.language_id == '' || this.languageObject.language_id == null) {
                success = false;
                this.languageObjectValidation.language_id = false;
            } else {
                this.languageObjectValidation.language_id = true;
            }
            this.languages.forEach((element) => {
                if (this.languageObject.language_id == element.language_id) {
                    success = false;
                    this.$alert(this.$t('alerts.languageAlreadyAdded'));
                }
            });
            if (this.languageObject.level == null) {
                this.$alert(this.$t('alerts.selectLevel'));
                success = false;
            }

            if (success) {
                this.languages.push(this.languageObject);
                this.languageObject = new ApplicationLanguage({});
                this.addLanguageDialog = false;
            }
        },
        selectedLanguage(value) {
            this.languageObject.language_display = value.label;
        },
        addEducation() {
            let success = true;

            if (this.educationObject.school_name == '') {
                success = false;
                this.educationObjectValidation.school_name = false;
            } else {
                this.educationObjectValidation.school_name = true;
            }
            if (this.educationObject.date_from == null) {
                success = false;
                this.educationObjectValidation.date_from = false;
            } else {
                this.educationObjectValidation.date_from = true;
            }
            if (this.educationObject.date_to == null) {
                success = false;
                this.educationObjectValidation.date_to = false;
            } else {
                this.educationObjectValidation.date_to = true;
            }
            if (this.educationObject.date_from > this.educationObject.date_to) {
                success = false;
                this.educationObjectValidation.date_from = false;
                this.educationObjectValidation.date_to = false;
            }

            if (success) {
                let date = new Date(this.educationObject.date_from);
                this.educationObject.date_from_display =
                    date.getDate() + '.' + (date.getMonth() + 1) + '.' + date.getFullYear();

                date = new Date(this.educationObject.date_to);
                this.educationObject.date_to_display =
                    date.getDate() + '.' + (date.getMonth() + 1) + '.' + date.getFullYear();

                this.educationItems.push(this.educationObject);
                this.educationObject = new Education({});
                this.addEducationDialog = false;
            }
        },
        removeEducation(index) {
            this.educationItems.splice(index, 1);
        },
        checkEmailExistance(email) {
            let vm = this;
            if (email !== null && email !== '') {
                this.$APICall(
                    'get',
                    'seafarers-email-verification/0/' + email,
                    {},
                    (data, success) => {
                        if (success) {
                            vm.seafarerValidation.email = true;
                            vm.emailVerified = true;
                        } else {
                            if (Object.hasOwn(data, 'custom')) {
                                vm.emailVerified = false;
                                vm.seafarerValidation.email = false;
                                vm.$alert(data.message);
                            } else {
                                vm.$alert(vm.$t('alerts.basicError'));
                            }
                        }
                    },
                    false,
                );
            }
        },
        addToDatabaseFull() {
            let success = true;
            let errorMessages = '';

            if (this.application.name === '') {
                success = false;
                this.applicationValidation.name = false;
            } else {
                if (this.application.name.length > 50) {
                    errorMessages +=
                        this.$t('alerts.lengthError')
                            .replace('%field%', this.$t('fields.name'))
                            .replace('%length%', '50') + '<br />';
                    this.applicationValidation.name = false;
                } else {
                    this.applicationValidation.name = true;
                }
            }

            if (this.application.surname === '') {
                success = false;
                this.applicationValidation.surname = false;
            } else {
                if (this.application.surname.length > 50) {
                    errorMessages +=
                        this.$t('alerts.lengthError')
                            .replace('%field%', this.$t('fields.surname'))
                            .replace('%length%', '50') + '<br />';
                    this.applicationValidation.surname = false;
                } else {
                    this.applicationValidation.surname = true;
                }
            }

            if (this.application.phone === '') {
                success = false;
                this.applicationValidation.phone = false;
            } else {
                if (this.application.phone.length > 50) {
                    errorMessages +=
                        this.$t('alerts.lengthError')
                            .replace('%field%', this.$t('fields.phone'))
                            .replace('%length%', '50') + '<br />';
                    this.applicationValidation.phone = false;
                } else {
                    this.applicationValidation.phone = true;
                }
            }

            if (this.application.seafarer_book === '') {
                success = false;
                this.applicationValidation.seafarer_book = false;
            } else {
                if (this.application.seafarer_book.length > 50) {
                    errorMessages +=
                        this.$t('alerts.lengthError')
                            .replace('%field%', this.$t('fields.seamanBook'))
                            .replace('%length%', '50') + '<br />';
                    this.applicationValidation.seafarer_book = false;
                } else {
                    this.applicationValidation.seafarer_book = true;
                }
            }

            if (!this.application.nationality_id) {
                success = false;
                this.applicationValidation.nationality_id = false;
            } else {
                this.applicationValidation.nationality_id = true;
            }

            if (!this.application.rank_id) {
                success = false;
                this.applicationValidation.rank_id = false;
            } else {
                this.applicationValidation.rank_id = true;
            }
            if (!this.application.available_date || this.application.available_date == null) {
                success = false;
                this.applicationValidation.available_date = false;
            } else {
                this.applicationValidation.available_date = true;
            }

            if (!this.application.date_of_birth || this.application.date_of_birth == null) {
                success = false;
                this.applicationValidation.date_of_birth = false;
            } else {
                let dateNow = new Date();
                let dateOfBirth = new Date(this.application.date_of_birth);

                if (dateNow < dateOfBirth) {
                    this.applicationValidation.date_of_birth = false;
                    errorMessages += this.$t('alerts.dateOfBirthDateOlder') + '<br/>';
                } else {
                    this.applicationValidation.date_of_birth = true;
                }
            }

            if (this.application.nationality_id == 56) {
                if (this.application.oib == '') {
                    success = false;
                    this.applicationValidation.oib = false;
                } else if (!this.$checkOIB(this.application.oib)) {
                    success = false;
                    this.applicationValidation.oib = false;
                    errorMessages += this.$t('alerts.oibFormattFailed') + '<br/>';
                } else {
                    this.applicationValidation.oib = true;
                }
            } else {
                // OIB obvezan samo za hrvatske državljane
                this.applicationValidation.oib = true;
            }

            if (!this.application.country_of_residency_id || this.application.country_of_residency_id == null) {
                success = false;
                this.applicationValidation.country_of_residency_id = false;
            } else {
                this.applicationValidation.country_of_residency_id = true;
            }

            if (this.application.place_of_birth === '') {
                success = false;
                this.applicationValidation.place_of_birth = false;
            } else {
                if (this.application.place_of_birth.length > 100) {
                    errorMessages +=
                        this.$t('alerts.lengthError')
                            .replace('%field%', this.$t('fields.placeOfBirth'))
                            .replace('%length%', '100') + '<br />';
                    this.applicationValidation.place_of_birth = false;
                } else {
                    this.applicationValidation.place_of_birth = true;
                }
            }

            if (!this.application.gender_id || this.application.gender_id == null) {
                success = false;
                this.applicationValidation.gender_id = false;
            } else {
                this.applicationValidation.gender_id = true;
            }

            if (!this.application.marital_status_id || this.application.marital_status_id == null) {
                success = false;
                this.applicationValidation.marital_status_id = false;
            } else {
                this.applicationValidation.marital_status_id = true;
            }

            if (!this.application.account_currency_id || this.application.account_currency_id == null) {
                success = false;
                this.applicationValidation.account_currency_id = false;
            } else {
                this.applicationValidation.account_currency_id = true;
            }

            if (this.application.street_name_and_number === '') {
                success = false;
                this.applicationValidation.street_name_and_number = false;
            } else {
                if (this.application.street_name_and_number.length > 250) {
                    errorMessages +=
                        this.$t('alerts.lengthError')
                            .replace('%field%', this.$t('fields.streetNameAndNumber'))
                            .replace('%length%', '250') + '<br />';
                    this.applicationValidation.street_name_and_number = false;
                } else {
                    this.applicationValidation.street_name_and_number = true;
                }
            }

            if (this.application.city === '') {
                success = false;
                this.applicationValidation.city = false;
            } else {
                if (this.application.city.length > 100) {
                    errorMessages +=
                        this.$t('alerts.lengthError')
                            .replace('%field%', this.$t('fields.city'))
                            .replace('%length%', '100') + '<br />';
                    this.applicationValidation.city = false;
                } else {
                    this.applicationValidation.city = true;
                }
            }

            if (this.application.post_code === '') {
                success = false;
                this.applicationValidation.post_code = false;
            } else {
                if (this.application.post_code.length > 50) {
                    errorMessages +=
                        this.$t('alerts.lengthError')
                            .replace('%field%', this.$t('fields.postCode'))
                            .replace('%length%', '50') + '<br />';
                    this.applicationValidation.post_code = false;
                } else {
                    this.applicationValidation.post_code = true;
                }
            }

            if (!this.application.country_id || this.application.country_id == null) {
                success = false;
                this.applicationValidation.country_id = false;
            } else {
                this.applicationValidation.country_id = true;
            }

            if (!this.application.airport_id || this.application.airport_id == null) {
                success = false;
                this.applicationValidation.airport_id = false;
            } else {
                this.applicationValidation.airport_id = true;
            }

            if (this.application.emergency_contact_name === '') {
                success = false;
                this.applicationValidation.emergency_contact_name = false;
            } else {
                if (this.application.emergency_contact_name.length > 250) {
                    errorMessages +=
                        this.$t('alerts.lengthError')
                            .replace('%field%', this.$t('fields.emergencyContactName'))
                            .replace('%length%', '250') + '<br />';
                    this.applicationValidation.emergency_contact_name = false;
                } else {
                    this.applicationValidation.emergency_contact_name = true;
                }
            }

            if (
                !this.application.emergency_contact_relationship_id ||
                this.application.emergency_contact_relationship_id == null
            ) {
                success = false;
                this.applicationValidation.emergency_contact_relationship_id = false;
            } else {
                this.applicationValidation.emergency_contact_relationship_id = true;
            }

            if (this.application.emergency_contact_street_name_and_number === '') {
                success = false;
                this.applicationValidation.emergency_contact_street_name_and_number = false;
            } else {
                if (this.application.emergency_contact_street_name_and_number.length > 250) {
                    errorMessages +=
                        this.$t('alerts.lengthError')
                            .replace('%field%', this.$t('fields.emergencyContactStreetNameAndNumber'))
                            .replace('%length%', '250') + '<br />';
                    this.applicationValidation.emergency_contact_street_name_and_number = false;
                } else {
                    this.applicationValidation.emergency_contact_street_name_and_number = true;
                }
            }

            if (this.application.emergency_contact_city === '') {
                success = false;
                this.applicationValidation.emergency_contact_city = false;
            } else {
                if (this.application.emergency_contact_city.length > 250) {
                    errorMessages +=
                        this.$t('alerts.lengthError')
                            .replace('%field%', this.$t('fields.emergencyContactCity'))
                            .replace('%length%', '250') + '<br />';
                    this.applicationValidation.emergency_contact_city = false;
                } else {
                    this.applicationValidation.emergency_contact_city = true;
                }
            }

            if (this.application.emergency_contact_post_code === '') {
                success = false;
                this.applicationValidation.emergency_contact_post_code = false;
            } else {
                if (this.application.emergency_contact_post_code.length > 250) {
                    errorMessages +=
                        this.$t('alerts.lengthError')
                            .replace('%field%', this.$t('fields.emergencyContactPostCode'))
                            .replace('%length%', '250') + '<br />';
                    this.applicationValidation.emergency_contact_post_code = false;
                } else {
                    this.applicationValidation.emergency_contact_post_code = true;
                }
            }

            if (
                !this.application.emergency_contact_country_id ||
                this.application.emergency_contact_country_id == null
            ) {
                success = false;
                this.applicationValidation.emergency_contact_country_id = false;
            } else {
                this.applicationValidation.emergency_contact_country_id = true;
            }

            if (this.application.contact_number === '') {
                success = false;
                this.applicationValidation.contact_number = false;
            } else {
                if (this.application.contact_number.length > 50) {
                    errorMessages +=
                        this.$t('alerts.lengthError')
                            .replace('%field%', this.$t('fields.emergencyContactNumber'))
                            .replace('%length%', '50') + '<br />';
                    this.applicationValidation.contact_number = false;
                } else {
                    this.applicationValidation.contact_number = true;
                }
            }

            if (this.application.contact_email === '') {
                success = false;
                this.applicationValidation.contact_email = false;
            } else {
                if (this.application.contact_email.length > 100) {
                    errorMessages +=
                        this.$t('alerts.lengthError')
                            .replace('%field%', this.$t('fields.emergencyContactEmail'))
                            .replace('%length%', '100') + '<br />';
                    this.applicationValidation.contact_email = false;
                } else {
                    this.applicationValidation.contact_email = true;
                }
            }

            if (errorMessages !== '') {
                this.$alert(errorMessages);
                success = false;
            }

            if (success) {
                this.application.languages = this.languagesItems;
                this.application.education = this.educationItems;
                this.application.navigation = this.navigationItems;
                this.application.documents = this.documentItems;

                this.saving = true;
                let addition = this.application.id;

                let vm = this;
                this.$verify(this.$t('alerts.approveAndSaveSeafarerToDatabase'), (result) => {
                    if (result) {
                        this.$APICall(
                            'post',
                            'create-seafarer-from-application/' + addition,
                            this.application,
                            (data, success) => {
                                if (success) {
                                    vm.$APICall('get', 'applications/' + vm.application.id, {}, (data, success) => {
                                        if (success) {
                                            let usableData = JSON.parse(JSON.stringify(data.item));
                                            let additionalDAta = JSON.parse(JSON.stringify(data.additional));
                                            vm.application = usableData;
                                            vm.vesselExperiences = JSON.parse(JSON.stringify(data.selected_vessels));
                                            vm.$myStore.commit('setBreadcrumbs', [
                                                {
                                                    text: vm.$t('modules.applications'),
                                                    href: '/#/applications',
                                                    disabled: false,
                                                },
                                                {
                                                    text: additionalDAta,
                                                    href: '/#/applications/' + vm.application.id,
                                                    disabled: true,
                                                },
                                            ]);
                                            vm.$nextTick(() => {
                                                vm.initialLoad = true;
                                            });
                                            vm.reloadNotes();
                                        }
                                    });
                                } else {
                                    this.$alert(this.$t('alerts.basicError'));
                                }
                                this.saving = false;
                            },
                            false,
                        );
                    }
                });
            }
        },
        saveNewSeafarer() {
            let success = this.emailVerified;
            let missingFields = '';
            if (this.seafarer.status_id == null) {
                success = false;
                this.seafarerValidation.status_id = false;
                missingFields += this.$t('fields.status') + '<br/>';
            } else {
                this.seafarerValidation.status_id = true;
            }
            if (this.seafarer.rank_id == null) {
                success = false;
                this.seafarerValidation.rank_id = false;
                missingFields += this.$t('fields.rank') + '<br/>';
            } else {
                this.seafarerValidation.rank_id = true;
            }
            if (this.seafarer.name == '') {
                success = false;
                this.seafarerValidation.name = false;
                missingFields += this.$t('fields.firstName') + '<br/>';
            } else {
                this.seafarerValidation.name = true;
            }
            if (this.seafarer.surname == '') {
                success = false;
                this.seafarerValidation.surname = false;
                missingFields += this.$t('fields.lastName') + '<br/>';
            } else {
                this.seafarerValidation.surname = true;
            }
            if (this.seafarer.date_of_birth == '' || this.seafarer.date_of_birth == null) {
                success = false;
                this.seafarerValidation.date_of_birth = false;
                missingFields += this.$t('fields.dateOfBirth') + '<br/>';
            } else {
                this.seafarerValidation.date_of_birth = true;
            }
            if (this.seafarer.nationality_id == null) {
                success = false;
                this.seafarerValidation.nationality_id = false;
                missingFields += this.$t('fields.nationality') + '<br/>';
            } else {
                this.seafarerValidation.nationality_id = true;
            }
            if (this.seafarer.country_of_residency_id == null) {
                success = false;
                this.seafarerValidation.country_of_residency_id = false;
                missingFields += this.$t('fields.countryOfResidency') + '<br/>';
            } else {
                this.seafarerValidation.country_of_residency_id = true;
            }
            if (this.seafarer.place_of_birth == '') {
                success = false;
                this.seafarerValidation.place_of_birth = false;
                missingFields += this.$t('fields.placeOfBirth') + '<br/>';
            } else {
                this.seafarerValidation.place_of_birth = true;
            }
            if (this.seafarer.marital_status_id == null) {
                success = false;
                this.seafarerValidation.marital_status_id = false;
                missingFields += this.$t('fields.maritalStatus') + '<br/>';
            } else {
                this.seafarerValidation.marital_status_id = true;
            }
            if (this.seafarer.phone == '') {
                success = false;
                this.seafarerValidation.phone = false;
                missingFields += this.$t('fields.phone') + '<br/>';
            } else {
                this.seafarerValidation.phone = true;
            }
            if (!this.$checkEmail(this.seafarer.email)) {
                success = false;
                this.seafarerValidation.email = false;
                missingFields += this.$t('fields.email') + '<br/>';
            } else {
                this.seafarerValidation.email = true;
            }
            if (this.seafarer.street_name_and_number == '') {
                success = false;
                this.seafarerValidation.street_name_and_number = false;
                missingFields += this.$t('fields.streetNameAndNumber') + '<br/>';
            } else {
                this.seafarerValidation.street_name_and_number = true;
            }
            if (this.seafarer.city == '') {
                success = false;
                this.seafarerValidation.city = false;
                missingFields += this.$t('fields.city') + '<br/>';
            } else {
                this.seafarerValidation.city = true;
            }
            if (this.seafarer.post_code == '') {
                success = false;
                this.seafarerValidation.post_code = false;
                missingFields += this.$t('fields.postalCode') + '<br/>';
            } else {
                this.seafarerValidation.post_code = true;
            }
            if (this.seafarer.country_id == '' || this.seafarer.country_id == null) {
                success = false;
                this.seafarerValidation.country_id = false;
                missingFields += this.$t('fields.country') + '<br/>';
            } else {
                this.seafarerValidation.country_id = true;
            }
            if (this.seafarer.airport_id === null) {
                success = false;
                this.seafarerValidation.airport_id = false;
                missingFields += this.$t('fields.closestIntAirport') + '<br/>';
            } else {
                this.seafarerValidation.airport_id = true;
            }
            if (this.seafarer.account_currency_id == null || this.seafarer.account_currency_id == '') {
                success = false;
                this.seafarerValidation.account_currency_id = false;
                missingFields += this.$t('fields.accountCurrency') + '<br/>';
            } else {
                this.seafarerValidation.account_currency_id = true;
            }
            if (this.seafarer.emergency_contact_name == '') {
                success = false;
                this.seafarerValidation.emergency_contact_name = false;
                missingFields += this.$t('fields.name') + '<br/>';
            } else {
                this.seafarerValidation.emergency_contact_name = true;
            }
            if (
                this.seafarer.emergency_contact_relationship_id == null ||
                this.seafarer.emergency_contact_relationship_id == ''
            ) {
                success = false;
                this.seafarerValidation.emergency_contact_relationship_id = false;
                missingFields += this.$t('fields.relationship') + '<br/>';
            } else {
                this.seafarerValidation.emergency_contact_relationship_id = true;
            }
            if (this.seafarer.emergency_contact_address == '') {
                success = false;
                this.seafarerValidation.emergency_contact_address = false;
                missingFields += this.$t('fields.address') + '<br/>';
            } else {
                this.seafarerValidation.emergency_contact_address = true;
            }
            if (
                this.seafarer.emergency_contact_country_id == null ||
                this.seafarer.emergency_contact_country_id == ''
            ) {
                success = false;
                this.seafarerValidation.emergency_contact_country_id = false;
                missingFields += this.$t('fields.country') + '<br/>';
            } else {
                this.seafarerValidation.emergency_contact_country_id = true;
            }
            if (this.seafarer.contact_number == '') {
                success = false;
                this.seafarerValidation.contact_number = false;
                missingFields += this.$t('fields.contactNumber') + '<br/>';
            } else {
                this.seafarerValidation.contact_number = true;
            }
            if (this.seafarer.contact_email != '') {
                if (!this.$checkEmail(this.seafarer.contact_email)) {
                    success = false;
                    this.seafarerValidation.contact_email = false;
                    missingFields += this.$t('fields.contactEmail') + '<br/>';
                } else {
                    this.seafarerValidation.contact_email = true;
                }
            }

            if (success) {
                let vm = this;
                this.$APICall(
                    'post',
                    'seafarers-on-application/' + this.application.id,
                    this.seafarer,
                    (data, success) => {
                        if (success) {
                            vm.$APICall('get', 'applications/' + vm.application.id, {}, (data, success) => {
                                if (success) {
                                    let usableData = JSON.parse(JSON.stringify(data.item));
                                    let additionalDAta = JSON.parse(JSON.stringify(data.additional));
                                    vm.application = usableData;
                                    vm.vesselExperiences = JSON.parse(JSON.stringify(data.selected_vessels));
                                    vm.$myStore.commit('setBreadcrumbs', [
                                        {
                                            text: vm.$t('modules.applications'),
                                            href: '/#/applications',
                                            disabled: false,
                                        },
                                        {
                                            text: additionalDAta,
                                            href: '/#/applications/' + vm.application.id,
                                            disabled: true,
                                        },
                                    ]);
                                    vm.$nextTick(() => {
                                        vm.initialLoad = true;
                                    });
                                    vm.reloadNotes();
                                }
                            });
                            vm.closeDialog();
                        } else {
                            vm.$alert(vm.$t('alerts.basicError'));
                        }
                    },
                );
            } else {
                let alert = this.$t('alerts.missingFields') + ' <br/> ' + missingFields;
                this.$alert(alert);
            }
        },
        closeDialog() {
            this.seafarer = new Seafarer({});
            this.seafarerValidation = new Seafarer({}, true);
            this.addSeafarerToDatabaseDialog = false;
        },
        addToDatabase() {
            this.seafarer = new Seafarer({});
            this.seafarerValidation = new Seafarer({}, true);
            this.seafarer.approved = true;
            this.seafarer.status_id = 1;
            this.seafarer.rank_id = this.application.rank_id;
            this.seafarer.name = this.application.name;
            this.seafarer.surname = this.application.surname;
            this.seafarer.nationality_id = this.application.nationality_id;
            this.seafarer.phone = this.application.phone;
            this.seafarer.email = this.application.email;

            this.addSeafarerToDatabaseDialog = true;
        },
        assignSeafarer() {
            let vm = this;
            if (this.application.seafarer_id == null) {
                vm.$notify(vm.$t('alerts.selectSeafarer'));
            } else {
                this.$APICall('get', 'seafarers/' + vm.application.seafarer_id, {}, (data, success) => {
                    if (success) {
                        let usableData = JSON.parse(JSON.stringify(data.object));
                        vm.application.name = usableData.name;
                        vm.application.surname = usableData.surname;
                        vm.application.email = usableData.email;
                        vm.application.phone = usableData.phone;
                        vm.application.nationality_id = usableData.nationality_id;
                        vm.application.seafarer_book = usableData.seafarer_book;
                    } else {
                        vm.$notify(vm.$t('alerts.basicError'));
                    }
                });
            }
        },
        openVacancy() {
            let routeData = this.$router.resolve('/vacancies/' + this.application.vacancy_id);
            window.open(routeData.href, '_blank');
        },
        createPlacement() {
            let vm = this;
            let addition = '/' + vm.application.id;
            this.$verify(this.$t('alerts.creatingPlacement'), (result) => {
                if (result) {
                    let placement = new Placement({});
                    placement.application_id = this.application.id;
                    placement.vacancy_id = this.application.vacancy_id;
                    placement.seafarer_id = this.application.seafarer_id;
                    placement.maritime_object_id = this.application.maritime_object_id;
                    placement.rank_id = this.application.rank_id;
                    placement.seniority = this.application.seniority;
                    placement.placement_status_id = 2;
                    placement.status_notes = this.application.status_notes;
                    placement.boc_date = this.application.boc_date;
                    placement.sign_on_date = this.application.sign_on_date;
                    placement.sign_off_date = null;
                    placement.eoc_date = null;
                    placement.flight_reservation = '';
                    placement.travel_info = '';
                    this.$APICall('post', 'placements', placement, (data, success) => {
                        if (success) {
                            if (data.response_message == 0) {
                                vm.$notify(vm.$t('alerts.cannotCreatePlannedPlacement'));
                            } else {
                                vm.$notify(vm.$t('alerts.placementCreated'));
                                vm.application.vessels = vm.vesselExperiences;
                                vm.application.created_placement = true;
                                vm.$APICall('put', 'applications' + addition, vm.application, (data, success) => {
                                    if (success) {
                                        vm.inEditMode = false;
                                        vm.$notify(vm.$t('alerts.basicUpdate'));
                                        vm.backClick();
                                    } else {
                                        vm.$alert(vm.$t('alerts.applicationExists'));
                                    }
                                });
                            }
                        } else {
                            vm.$notify(data && data.message ? data.message : vm.$t('alerts.basicError'));
                        }
                    });
                }
            });
        },
        changeTab(id) {
            this.tab = this.currentTab;
            this.tabMain = this.currentTab;
            switch (this.currentTab) {
                case 'information':
                    this.lockKey = 'application';
                    break;
                case 'document-checklist':
                    this.lockKey = 'document-checklist';
                    break;
                default:
                    break;
            }
            if (this.inEditMode) {
                let vm = this;
                this.$verify(this.$t('alerts.leaveQuestion'), (result) => {
                    if (result) {
                        clearInterval(vm.lockTimer);
                        vm.$removeLock(vm, vm.lockKey + '|' + vm.application.id);
                        vm.reload = vm.reload + 1;
                        vm.tab = id;
                        vm.currentTab = id;
                        vm.tabMain = id;
                        vm.inEditMode = false;
                    }
                });
            } else {
                this.tab = id;
                this.currentTab = id;
                this.tabMain = id;
            }
        },
        saveNote() {
            let vm = this;
            if (this.note.note == '') {
                this.$notify(vm.$t('alerts.writeNote'));
            } else {
                this.note.application_id = this.application.id;
                this.note.user_id = this.$myStore.state.user.id;
                this.note.timestamp = Date.now();
                this.$APICall('post', 'application-notes', this.note, (data, succes) => {
                    if (succes) {
                        vm.reloadNotes();
                        vm.note = new ApplicationNote({});
                    } else {
                        vm.$notify(vm.$t('alerts.basicError'));
                    }
                });
            }
        },
        editClick() {
            let vm = this;
            this.$setLock(this, this.lockKey + '|' + this.application.id, (data) => {
                if (data.success) {
                    vm.inEditMode = true;
                    vm.lockTimer = setInterval(() => {
                        vm.$setLock(vm, vm.lockKey + '|' + vm.application.id);
                    }, 10000);
                    if (this.application.vacancy_id != null) {
                        vm.maritimeObjectReadOnly = false;
                        vm.rankReadOnly = false;
                    } else {
                        vm.maritimeObjectReadOnly = true;
                        vm.rankReadOnly = true;
                    }
                } else {
                    vm.$alert(
                        vm
                            .$t('alerts.recordLocked')
                            .split('%name%')
                            .join(data.locked_by.first_name + ' ' + data.locked_by.last_name),
                    );
                }
            });
        },
        backClick() {
            this.$router.go(-1);
        },
        reloadNotes() {
            let vm = this;
            this.$APICall('get', 'application-notes/' + vm.application.id, {}, (data, succes) => {
                if (succes) {
                    vm.notesList = data.items;
                }
            });
        },
        saveClick(goBack) {
            let success = true;
            let missingFields = '';

            if (this.application.seafarer_id == '' || this.application.seafarer_id == null) {
                if (this.application.name == '') {
                    success = false;
                    this.applicationValidation.name = false;
                } else {
                    this.applicationValidation.name = true;
                }
                if (this.application.surname == '') {
                    success = false;
                    this.applicationValidation.surname = false;
                } else {
                    this.applicationValidation.surname = true;
                }
                if (this.application.email == '') {
                    success = false;
                    this.applicationValidation.email = false;
                } else {
                    this.applicationValidation.email = true;
                }
                if (this.application.phone == '') {
                    success = false;
                    this.applicationValidation.phone = false;
                } else {
                    this.applicationValidation.phone = true;
                }
                if (this.application.nationality_id == '' || this.application.nationality_id == null) {
                    success = false;
                    this.applicationValidation.nationality_id = false;
                } else {
                    this.applicationValidation.nationality_id = true;
                }
                if (this.application.seafarer_book == '') {
                    success = false;
                    this.applicationValidation.seafarer_book = false;
                } else {
                    this.applicationValidation.seafarer_book = true;
                }
                if (this.application.candidate_resume == '' || this.application.candidate_resume == null) {
                    success = false;
                    this.applicationValidation.candidate_resume = false;
                } else {
                    this.applicationValidation.candidate_resume = true;
                }
                if (success) {
                    this.applicationValidation.seafarer_id = true;
                } else {
                    this.applicationValidation.seafarer_id = false;
                    missingFields += this.$t('fields.seafarer') + '<br/>';
                }
            } else {
                this.applicationValidation.seafarer_id = true;
                this.applicationValidation.name = true;
                this.applicationValidation.surname = true;
                this.applicationValidation.email = true;
                this.applicationValidation.phone = true;
                this.applicationValidation.nationality_id = true;
                this.applicationValidation.seafarer_book = true;
                this.applicationValidation.candidate_resume = true;
            }
            if (this.application.application_status_id == '' || this.application.application_status_id == null) {
                success = false;
                this.applicationValidation.application_status_id = false;
                missingFields += this.$t('fields.status') + '<br/>';
            } else {
                this.applicationValidation.application_status_id = true;
            }

            if (success) {
                let vm = this;
                let action = 'post';
                let addition = '';
                if (vm.application.id != 0) {
                    action = 'put';
                    addition = '/' + vm.application.id;
                }
                this.application.vessels = vm.vesselExperiences;
                this.application.languages = vm.languagesItems;
                this.application.education = vm.educationItems;
                this.application.navigation = vm.navigationItems;
                this.application.documents = vm.documentItems;
                this.$APICall(action, 'applications' + addition, this.application, (data, success) => {
                    if (success) {
                        vm.inEditMode = false;
                        if (vm.application.id == 0) {
                            vm.$notify(vm.$t('alerts.basicAdd'));
                            // Zapiši id novog zapisa da sljedeći Save radi PUT, ne novi POST (FE-02).
                            if (data && data.id) {
                                vm.application.id = data.id;
                                vm.$myStore.commit('setBreadcrumbs', [
                                    {
                                        text: vm.$t('modules.applications'),
                                        href: '/#/applications',
                                        disabled: false,
                                    },
                                    {
                                        text: vm.application.name + ' ' + vm.application.surname,
                                        href: '/#/applications/' + vm.application.id,
                                        disabled: true,
                                    },
                                ]);
                            }
                        } else {
                            vm.$notify(vm.$t('alerts.basicUpdate'));
                        }
                        vm.$triggerReload();
                        if (goBack) {
                            vm.backClick();
                        }
                    } else {
                        vm.$alert(vm.$t('alerts.applicationExists'));
                    }
                    if (this.lockTimer !== null) clearInterval(this.lockTimer);
                    this.$removeLock(this, this.lockKey + '|' + this.application.id);
                });
            } else {
                let alert = this.$t('alerts.missingFields') + ' <br/> ' + missingFields;
                this.$alert(alert);
            }
        },
    },

    beforeRouteLeave(to, from, next) {
        if (this.inEditMode) {
            let vm = this;
            this.$verify(this.$t('alerts.leaveQuestion'), (result) => {
                if (result) {
                    let elHtml = document.getElementsByTagName('html')[0];
                    elHtml.style.overflowY = 'auto';
                    if (vm.lockTimer !== null) clearInterval(vm.lockTimer);
                    vm.$removeLock(vm, vm.lockKey + '|' + vm.application.id);
                    next(true);
                } else {
                    next(false);
                }
            });
        } else {
            let elHtml = document.getElementsByTagName('html')[0];
            elHtml.style.overflowY = 'auto';
            next(true);
        }
    },
    mounted() {
        let elHtml = document.getElementsByTagName('html')[0];
        elHtml.style.overflowY = 'hidden';
        if (!this.$myStore.state.loggedIn) {
            this.$router.replace('login');
        }
        let vm = this;
        if (this.application.id != 0) {
            this.$APICall('get', 'applications/' + this.application.id, {}, (data, success) => {
                if (success) {
                    let usableData = JSON.parse(JSON.stringify(data.item));
                    let additionalDAta = JSON.parse(JSON.stringify(data.additional));
                    vm.application = usableData;
                    vm.vesselExperiences = JSON.parse(JSON.stringify(data.selected_vessels));
                    vm.originSeafarerName = usableData.name;
                    vm.originSeafarerSurname = usableData.surname;
                    vm.originSeafarerEmail = usableData.email;
                    vm.originSeafarerPhone = usableData.phone;
                    vm.originSeafarerNationalityId = usableData.nationality_id;
                    vm.originSeafarerSeafarerBook = usableData.seafarer_book;
                    vm.educationItems = data.education;
                    vm.languagesItems = data.languages;
                    vm.navigationItems = data.navigations;

                    vm.documentItems = data.seafarer_document;
                    vm.$myStore.commit('setBreadcrumbs', [
                        {
                            text: vm.$t('modules.applications'),
                            href: '/#/applications',
                            disabled: false,
                        },
                        {
                            text: additionalDAta,
                            href: '/#/applications/' + vm.application.id,
                            disabled: true,
                        },
                    ]);
                    vm.$nextTick(() => {
                        vm.initialLoad = true;
                    });
                    vm.reloadNotes();
                }
            });
        } else {
            this.$myStore.commit('setBreadcrumbs', [
                {
                    text: this.$t('modules.applications'),
                    href: '/#/applications',
                    disabled: false,
                },
                {
                    text: this.$t('modules.newApplication'),
                    href: '/#/applications/0',
                    disabled: true,
                },
            ]);
            this.inEditMode = true;
            this.initialLoad = true;
        }
    },
};
</script>

<style scoped></style>
